<template>
    <div class="task-detail">
        <SideLeftTree v-if="!isNewPage" @changeLeftTree="changeLeftTree"/>
        <el-card class="box-card task-desc" style="overflow: initial;" shadow="always" >
            <div class="taskdetail-top">
                <div style="padding-bottom: 5px;">
                    <!-- <el-tooltip :content="isCollapse?'收起左侧列表':'展开左侧列表'" placement="top">
                    <el-switch
                        v-model="isCollapse"
                        @change="changeLeftList">
                    </el-switch>
                    </el-tooltip> -->
                    <span>[<font color='green'>{{taskInfo.name}}</font>]</span>
                    <span>
                    -- 来自流程实例【
                        <el-tooltip :content="taskInfo.processInstanceName" placement="top">
                            <font color='blue' style="cursor:pointer;" @click.stop="linkToProcessDetail()">{{taskInfo.processInstanceName | ellipsis}}</font>
                        </el-tooltip>
                    】
                    </span>
                </div>
                <div class="text-desc">
                    <span>流程发起人：{{taskInfo.startBy? taskInfo.startBy.trueName : ""}}</span> <br/>
                </div>
                <div class="text-desc desc-content1">
                    <span>任务开始时间：{{taskInfo.created}}</span> <br/>
                </div>
                <div class="taskInfo-btns">
                    <el-button   title='任务详情' circle icon="el-icon-info" @click="handelShowTaskInfo"></el-button>
                    <el-button v-if="taskInfo.reports && taskInfo.reports.length>0" :loading="exportLoading" title='导出报表' circle icon="el-icon-download" @click="exportReportList"></el-button>
                    <el-button v-if="taskInfo.taskNode&&taskInfo.taskNode.execLog===0"  title='任务表单库' circle icon="el-icon-goods" @click="handelShowForms"></el-button>
                    <el-button v-if="taskInfo.taskNode&&taskInfo.taskNode.execLog===0"   title='流程图' circle icon="el-icon-picture-outline" @click="handelShowDiagram"></el-button>
                    <el-button v-if="taskInfo.hasSubProcess==='1'" size="mini" title='主子流程关系图' circle icon="el-icon-s-grid" @click="handelShowProcessRelate"></el-button>
                    <el-button v-if="taskInfo.showNextUserTaskConfigBtn" title='下一任务配置' circle icon="el-icon-setting" @click="handleNextTaskConfig"></el-button>
                    <template v-if="!isRead">
                        <el-button v-if="taskInfo.canClaimTask" type="primary" plain @click="handleTaskClaim">认领</el-button>
                        <el-button v-if="taskInfo.canShowButton" type="primary" plain @click="handleTransferAssignee">转办</el-button>
                        <!-- <el-button v-if="taskInfo.canShowButton" type="primary" plain @click="handleTaskRevoke">回退</el-button> -->
                        <el-button v-if="!taskInfo.hiddenTemporaryButton && !(taskInfo.taskNode && taskInfo.taskNode.updHisProcessDataFlag===1) && !(this.taskInfo.taskNode && this.taskInfo.taskNode.isApproval === 1 &&  this.approvalInstanceList && this.approvalInstanceList.length>0) && ((taskInfo.canClaimTask===false && (taskInfo.memberOfCandidateUsers||taskInfo.initiatorCanCompleteTask)) || taskInfo.canShowButton || taskInfo.showProcessStoregeBtn)" type="primary" plain @click="handleTaskTemporarySave">暂存</el-button>
                        <template  v-if="taskInfo.canShowButton" >
                           <!-- 假如为审批流节点，并且是审批流通过后自动完成任务的，就不显示具体任务按钮了 -->
                          <el-button
                              v-if="!(taskInfo.taskNode && taskInfo.taskNode.isApproval===1 && taskInfo.taskNode.autoCompleteByApproval===1)"
                              v-for="(btn, index) in completeBtns"
                              :key="index"
                              type="primary"
                              v-preventReClick = "3000"
                              @click="handleTaskCompleteConfirm(btn)">
                              {{btn.operateName}}
                          </el-button>
                        </template>
                        <!--
                            <el-button v-if="taskInfo.endDate" type="primary" plain @click="handleTaskDelete">删除</el-button>
                        -->
                        <el-tooltip content="已完成的任务可以隐藏，隐藏后就不在任务列表显示了。目前暂不支持隐藏后再次显示，若要显示需要联系客服处理。" placement="top" effect="light">
                            <el-button v-if="taskInfo.endDate" type="primary" plain @click="handleTaskHidden">隐藏</el-button>
                        </el-tooltip>
                    </template>
                    <el-row v-if="canJumpTask" >
                     <el-input v-model="jumpTaskId"  placeholder="请输入要跳转的目标任务的任务定义id"/>
                     <el-button type="primary" plain @click="jumpTask">跳转指定任务</el-button>
                    </el-row>
                    
                    <el-row v-if="canJumpTask" >
                        <el-col :span="10">
                        <el-input  v-model="updAssignerTaskId"  placeholder="请输入要修改目标任务的任务实例id"/>
                        </el-col>
                        <el-col :span="10">
                        <el-input  v-model="updAssignerUserId"  placeholder="请输入任务负责人userid"/>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" plain @click="updAssignerUser">修改任务负责人</el-button>
                         </el-col>
                     </el-row>
                </div>
            </div>
        </el-card>
        <!-- tab页签组 -->
        <div class="task-content">
            <el-tabs  :tab-position="tabPosition" @tab-click="handleTabClick" v-model="tabName" type="border-card">
                <!-- 任务表单 -->
                <el-tab-pane  v-if="(taskInfo.hasOwnProperty('formObj') && taskInfo.formObj.structure.length>0) || btnConditions.length>0 || isViewOperateOpinion" class="content-taskForms" name="first" label="任务表单">
                    <template  v-if="btnConditions.length>0">
                        <el-row
                            v-for="(condition, index2) in btnConditions"
                            :key="condition.key" >
                            <el-col class="opinionClass" :span="3">
                                申请条件:
                            </el-col>
                            <el-col :span="6">
                                <el-input disabled v-model="condition.varName"></el-input>
                            </el-col>
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col class="opinionClass" :span="3">
                                条件值:
                            </el-col>
                                <el-col :span="6">
                                <el-input v-model="condition.varVal" />
                            </el-col>
                        </el-row>
                    </template>
                    <el-row v-if="isViewOperateOpinion">
                        <el-col  :class="isOperateOpinionRequired?'opinionClass':''" :span="3">
                            审批意见:
                        </el-col>
                        <el-col :span="15">
                            <!-- <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="taskInfo.operateOpinion" ></el-input> -->
                            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="operateOpinionTxt" ></el-input>
                        </el-col>
                    </el-row>

                    <!-- style="height:380px;"  class="my-task-list" -->
                    <el-collapse :key="loadTimerList" class="my-task-list"  v-if="isShowForm" v-model="collapseActiveName" accordion>
                        <el-collapse-item v-for="(form, index) in forms" :key="form.id" :title="form.formName" :name="form.id">
                            <template slot="title">
                                <div class='el-collapse-title'>
                                    <span >【{{form.formName}}】</span>
                                </div>
                                <el-tooltip class="item" effect="light" content="用于显示该表单的审批执行状态" placement="top">
                                    <el-checkbox style="margin-right:10px;"  v-if="formData[index] && formData[index].hasOwnProperty('approvalInstanceId') && formData[index].approvalInstanceId" class="checkBox-style" v-model="formData[index].approvalStatusRecord"  @change="handleApprovalDetail(index)"><el-tag size="mini">审批执行状态</el-tag></el-checkbox>
                                </el-tooltip>
                                <el-button  size="mini" icon="el-icon-printer" @click.stop="handlePrint(index)">打印</el-button>
                                <el-button v-if="form.isApprovalFilterForm" size="mini" icon="el-icon-view" @click.stop="handleFromDataFilter(index,form)">查看待还款数据</el-button>
                                <el-button v-if="!taskInfo.endDate && isAssignee && (canStartApproval || (form.formSynApprovalFlag && form.formSynApprovalFlag === 1))" type="primary" icon="el-icon-circle-plus" @click.stop="handleStartApproval(index)">发起审批</el-button>
                                <el-button v-if="taskInfo.taskNode && taskInfo.taskNode.updHisProcessDataFlag===0" style="margin-right: 10px" size="mini" icon="el-icon-document-copy" @click.stop="handleSelectFromHis(index,form)">复制数据</el-button>
                                <el-button v-if="taskInfo.taskNode && taskInfo.taskNode.updHisProcessDataFlag===1" style="margin-right: 10px" size="mini" icon="el-icon-document-copy" @click.stop="handleCloneFromHis(index,form)">引用历史数据</el-button>
                                <!-- <el-button style="margin-right: 10px" size="mini" icon="el-icon-rank" @click.stop="handleFullScreen(formData[index],form)">全屏</el-button> -->
                            </template>

                            <el-form v-if="formData[index] && formData[index].hasOwnProperty('values')" :model="formData[index].values"  :ref="'customForm'+index" label-width="165px">
                                <div :key="loadTimerField" >
                                    <!--模式1 -->
                                    <!-- <FieldItem
                                            v-for="(field, index2) in form.fieldsList"
                                            :findex="index2"
                                            :ref="'fieldItemChild'+index2"
                                            :formId="form.id"
                                            :key="field.fieldId"
                                            :field="field"
                                            :isRead="field.isRead"
                                            :isView="field.isView"
                                            :formData="formData[index].values"
                                            :colSpan="form.colSpan"
                                            :taskInstance="taskInfo"
                                            :processModelFormsObj="processModelFormsObj"
                                            :processInstance="processInstance"
                                            :fieldsList="form.fieldsList"
                                            @loadLinkData="loadLinkData"
                                            @refreshViewField="refreshViewField"
                                            v-if="(field.isView&&taskInfo) || !field.formFieldAuth || field.formFieldAuth=='1'"
                                    /> -->
                                    <!--审批记录-->
                                    <template>
                                        <div v-if="formData[index] && formData[index].hasOwnProperty('approvalInstanceId') && formData[index].approvalInstanceId && formData[index].approvalStatusRecord">
                                            <el-divider content-position="left">审批执行状态</el-divider>
                                            <el-row :loading="approvalLoading">
                                                <el-steps v-if="approvalDetail.approvalMethod != 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success">
                                                    <el-step v-for="(item, index) in approvalDetail.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('description')?item.description:''"></el-step>
                                                </el-steps>
                                                <el-steps v-if="approvalDetail.approvalMethod == 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success">
                                                    <el-step v-for="(item, index) in approvalDetail.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('description')?item.description:''">
                                                        <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(approvalDetail.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                                            <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                                        </el-breadcrumb>
                                                    </el-step>
                                                </el-steps>
                                            </el-row>
                                            <el-divider content-position="left"></el-divider>
                                        </div>
                                    </template>
                                    <!-- 模式3  -->
                                    <template v-for="(field,index2) in form.fieldsList" >
                                    <template v-if="isShowNormalField(field,index,formData[index])">
                                        <FieldItem
                                            :findex="index2"
                                            :formIndex="index"
                                            :ref="'fieldItemChild'+index2"
                                            :formId="form.id"
                                            :formConfig="form"
                                            :key="field.id"
                                            :field="field"
                                            :isRead="fieldIsRead(field)"
                                            :isView="field.isView"
                                            :formData="formData[index].values"
                                            :colSpan="form.colSpan"
                                            :taskInstance="taskInfo"
                                            :processModelFormsObj="processModelFormsObj"
                                            :processInstance="processInstance"
                                            :fieldsList="form.fieldsList"
                                            :linkFieldCache="linkFieldCache"
                                            :relateModelList="relateModelList"
                                            @loadLinkData="loadLinkData"
                                            @refreshViewField="refreshViewField"
                                            @asynMainFormData="asynMainFormData"
                                            @refreshTaskDetail="refreshTaskDetail"
                                            @asynFormUserFieldData="asynFormUserFieldData"
                                            @dealSpecialField="dealSpecialField"
                                            v-if="(field.isView&&taskInfo) || !field.formFieldAuth || field.formFieldAuth=='1'"
                                            />
                                    </template>
                                    </template>
                                    <div class="render-form-item" style="width: 100%; float: left;" v-if="(formData[index].values['subFormViewMode']!==0 && formData[index].ext1===1) || (formData[index].values['subFormViewMode'] && (formData[index].values['subFormViewMode'] > 0))">
                                        <el-row>
                                            <el-form-item label="" style="width: 100%;">
                                            <el-tabs :key="loadTimerField" v-model="defaultViewOrder" >
                                                <template v-for="(field,index2) in form.fieldsList" >
                                                    <template v-if="field.type === 'subform' && isShowCascadeField(field, formData[index].values)" >
                                                    <el-tab-pane  :key="index2" :label="getSubformName(formData[index].values,field)" :name="index2+''">
                                                        <FieldItem
                                                            :findex="index2"
                                                            :ref="'fieldItemChild'+index2"
                                                            :formId="form.id"
                                                            :formConfig="form"
                                                            :key="field.id"
                                                            :field="field"
                                                            :isRead="fieldIsRead(field)"
                                                            :isView="field.isView"
                                                            :formData="formData[index].values"
                                                            :colSpan="form.colSpan"
                                                            :taskInstance="taskInfo"
                                                            :processModelFormsObj="processModelFormsObj"
                                                            :processInstance="processInstance"
                                                            :fieldsList="form.fieldsList"
                                                            :subFormViewMode="1"
                                                            :linkFieldCache="linkFieldCache"
                                                            :relateModelList="relateModelList"
                                                            @loadLinkData="loadLinkData"
                                                            @refreshViewField="refreshViewField"
                                                            @asynMainFormData="asynMainFormData"
                                                            @refreshTaskDetail="refreshTaskDetail"
                                                            @asynFormUserFieldData="asynFormUserFieldData"
                                                            @dealSpecialField="dealSpecialField"
                                                            v-if="(field.isView&&taskInfo) || !field.formFieldAuth || field.formFieldAuth=='1'"
                                                        />
                                                    </el-tab-pane>
                                                    </template>
                                                </template>
                                            </el-tabs>
                                            </el-form-item>
                                        </el-row>
                                    </div>
                                </div>
                                <!-- 关联的其他表单数据 add by hezhen 20210327    start-->
                                <div class="render-form-item" v-if="index===0 && showRelateFormTab" style="width: 100%; float: left;">
                                    <el-row>
                                    <el-form-item class="relateFormTab" label="" style="width: 100%;">
                                        <el-tabs :key="loadTimerRelate" @tab-click="handleRelateFormTabClick" v-model="relateFormTabName" >
                                            <template v-for="(model, index3) in relateModelList" >
                                                <el-tab-pane :key="model.id" :label="model.modelName" :name="model.id" v-if="!model.hiddenElement">
                                                    <RelateFormList
                                                        :ref="'relateModelList' + model.id"
                                                        :key="loadTimerRelate"
                                                        :selectedModel="model"
                                                        :taskInfo="taskInfo"
                                                        :tempFormData="tempFormData"
                                                        :parentFormInfo="formInfo"
                                                        :parentFormData="formData"
                                                        :ifShowBtn="!isRead"
                                                        @refTempFormData="refTempFormData"
                                                    />
                                                </el-tab-pane>
                                            </template>
                                        </el-tabs>
                                    </el-form-item>
                                    </el-row>
                                </div>
                                <!-- 关联的其他表单数据 add by hezhen 20210327    end-->
                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                </el-tab-pane> 
                <!-- 文件列表 -->
                <el-tab-pane v-if="taskInfo.hasOwnProperty('isShowFileList') && taskInfo.isShowFileList" name="second" label="文件列表">
                    <ArchiveFilesList ref="processFiles" :key="loadTimerFile" bizType="task" :taskAssigneeId="this.taskInfo.executor.assigneeUsers" :taskId="this.taskInfo.id" :processInstanceId="this.taskInfo.processInstanceId" :templateId="this.taskInfo.archiveTemplateId" :isSubProcess="isSubProcess" :taskInfo="taskInfo" :isCloseFileUpload="this.taskInfo.isCloseFileUpload"/>
                </el-tab-pane>
                <!-- 沟通列表 -->
                <el-tab-pane v-if="taskInfo.hasOwnProperty('isShowComment') && taskInfo.isShowComment" name="third" label="沟通留言">
                    <Comment
                        v-if="isShowMyComment"
                        class="comments"
                        :list="commentList"
                        :isMsgToUsers="true"
                        @commentAdd="handleCommentAdd"
                        @commentDelete="handleCommentDelete"
                        @commentSend="chooseCommentUser"
                    />
                </el-tab-pane>
                <!-- 作业指导书 -->
                <el-tab-pane v-if="taskInfo.hasOwnProperty('wiFileInfo') && (taskInfo.wiFileInfo.hasOwnProperty('instructions') || taskInfo.wiFileInfo.fileList.length>0)" name="four" label="作业指导书">
                    <WorkInstruction :wiFileInfo="taskInfo.wiFileInfo?taskInfo.wiFileInfo:{}" :isShowUploadBtn="false"  @previewFile="previewFile" />
                </el-tab-pane>
                <!-- 作业指导书 -->
                <el-tab-pane v-if="isShowPreview" name="fifth" label="作业指导书预览">
                    <div class="wi-preview">
                        <iframe class="preview-page" :src="previewUrl" frameborder="0"></iframe>
                    </div>
                </el-tab-pane>
                <!-- 审批流列表 -->
                <el-tab-pane v-if="taskInfo.hasOwnProperty('isShowApproveList') && taskInfo.isShowApproveList && !isShowProcess" name="sixth" label="审批流列表">
                    <MyApproval
                        ref="myApproval"
                        v-if="isShowMyApproval"
                        :key="loadTimer"
                        :busiProcessInstanceId="this.taskInfo.processInstanceId"
                        :busiProcessInstanceName="this.taskInfo.processInstanceName"
                        :busiTaskInstanceId="this.taskInfo.id"
                        :onlyOneApproval="this.taskInfo.taskNode.onlyOneApproval"
                        :belongProcessFlag="2"
                        :isFullScreen="isFullScreenForApproval"
                        :selectedTemplate="selectedTemplate"
                        :isRead="isRead"
                        :taskParam = "taskParam"
                        :processModelFormsObj="processModelFormsObj"
                        @refreshTaskDetail="refreshTaskDetail"
                        @handleFullScreenForApproval="handleFullScreenForApproval" />
                </el-tab-pane>
                <!-- 业务流列表 -->
                <el-tab-pane name="seventh" label="业务流列表" v-if="isShowProcess" >
                    <div style="max-height: 150px;overflow: auto;">
                        <el-table :data="selectedProcessTemplate" :border="true" style="height: auto;margin-bottom: 20px;margin-top:-10px;">
                            <el-table-column
                                label="流程模板名称"
                                :show-overflow-tooltip="true"
                                align="center">
                                <template slot-scope="scope">
                                    <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.subProcessTemplateName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="版本号"
                                :show-overflow-tooltip="true"
                                align="center"
                                width="80">
                                <template slot-scope="scope">
                                    v{{scope.row.subProcessTemplateVersion}}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="操作" fixed="right" width="310">
                                <template slot-scope="scope">
                                    <el-tooltip  v-if="taskInfo.hasOwnProperty('subformSubprocessConfig')"  class="item" effect="light" content="通过配置目标表单内的子表单数据后可批量发起子流程" placement="top">
                                      <el-button  type="primary" style="margin-left:20px;margin-right:20px;" icon="el-icon-s-tools" round @click="handleSaveSubProcess(scope.row)">子流程管理</el-button>
                                    </el-tooltip>
                                    <el-button size="mini" style="margin-left:-20px;margin-right:20px" icon="el-icon-view" title="预览" circle @click="handleViewProcessTemplate(scope.row)"></el-button>
                                    <el-button size="mini"  v-if="!taskInfo.hasOwnProperty('subformSubprocessConfig')"  type="success" icon="el-icon-caret-right" title="发起流程" circle @click="handleStartProcessInstance(scope.row)"></el-button>
                                    <el-button size="mini"  v-if="!taskInfo.hasOwnProperty('subformSubprocessConfig')"  type="success" icon="el-icon-video-play" title="批量发起流程" circle @click="handleStartProcessInstanceBatchAdd(scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="height:320px" >
                        <span>子流程列表</span>
                        <div style="margin-top: -25px" >
                            <MyProcessListMode  ref="myProcessListMode" :taskInfo="taskInfo" :tableHeight="250" :isShowNewMode="false" :isListView="true"  :isSearchNowTasks="true" :hideModeSwich="hideModeSwich" :subProcessList="true"/>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog
            title="任务详情"
            top="1vh"
            width="60%"
            append-to-body
            :visible.sync="isShowTaskInfo">
            <el-form ref="taskDetailform" style="margin-top: -5%;" :model="taskInfo" label-width="120px">
                <el-divider content-position="left"><b>人员信息：</b></el-divider>
                <el-form-item label="流程发起人">
                <el-input readonly v-if="taskInfo.hasOwnProperty('startBy')" v-model="taskInfo.startBy.trueName"></el-input>
                <el-input readonly v-else > -- </el-input>
                </el-form-item>
                <el-form-item label="负责人">
                    <el-input v-if="taskInfo.hasOwnProperty('assignee')" readonly v-model="taskInfo.assignee.trueName"></el-input>
                    <el-input v-else readonly placeholder="暂无负责人" ></el-input>
                </el-form-item>
                <el-form-item label="候选人(抄送)">
                <el-input readonly v-model="taskInfo.candidateUsersView"></el-input>
                </el-form-item>
                <el-form-item label="参与人">
                <el-input readonly v-model="taskInfo.participantUsersView"></el-input>
                </el-form-item>
                <el-divider content-position="left"><b>任务信息：</b></el-divider>
                <el-form-item label="实际开始时间">
                <el-input readonly v-model="taskInfo.created"></el-input>
                </el-form-item>
                <el-form-item label="计划完成时间">
                <el-input readonly v-if="taskInfo.hasOwnProperty('taskNode')" v-model="taskInfo.taskNode.dueDate"></el-input>
                <el-input v-else readonly placeholder="暂未设置" ></el-input>
                </el-form-item>
                <el-form-item label="任务难度分">
                <el-input readonly v-if="taskInfo.hasOwnProperty('taskNode')" v-model="taskInfo.taskNode.difficultScore"></el-input>
                <el-input v-else readonly placeholder="暂未设置" ></el-input>
                </el-form-item>
                <el-divider content-position="left"><b>任务执行说明：</b></el-divider>
                <el-form-item label="参与人">
                    <el-input readonly v-if="taskInfo.hasOwnProperty('taskNode')" type="textarea"  v-model="taskInfo.taskNode.desc"></el-input>
                    <el-input v-else readonly placeholder="暂未设置" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowTaskInfo = false" >取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="任务转办"
            append-to-body
            :visible.sync="isShowTransferAssigneeDialog">
            <el-form size="mini" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="选择转办人员">
                            <!-- <User style="width:150px" :field="{}" ref="userChild" :formData="{}" @nodeClick="selectTrigger"/> -->
                            <el-input readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                        </el-form-item>
                        <UserOrgPop :key="loadTimerUser" :multiple="false" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowTransferAssigneeDialog = false" >取 消</el-button>
                <el-button  type="primary" @click="transferTask">确定转办</el-button>
            </span>
        </el-dialog>
        <!-- 显示图标 -->
        <el-dialog
            title="流程图"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowDiagram"
            >
            <ProcessDiagram
                ref="diagrams"
                :processInstance="instances"
                :taskList="taskList"
                :archiveTemplateTreeList="archiveTemplateTreeList"
            />
        </el-dialog>

        <!-- 全屏展示审批列表 -->
        <el-dialog
            title="审批流列表"
            :fullscreen="true"
            append-to-body
            :visible.sync="isShowFullScreenForApproval"
            @close="hideFullScreenDialogForApproval">
            <MyApproval
                ref="taskDetailMyApproval"
                v-if="isShowFullScreenForApproval"
                :busiProcessInstanceId="this.taskInfo.processInstanceId"
                :busiTaskInstanceId="this.taskInfo.id"
                :onlyOneApproval="this.taskInfo.taskNode.onlyOneApproval"
                :belongProcessFlag="2"
                :isFullScreen="isFullScreenForApproval"
                :isRead="isRead"
                :selectedTemplate="selectedTemplate"
                :isFromProcessTaskForms="isFromProcessTaskForms"
                :taskParam="taskParam"
                @refreshTaskDetail="refreshTaskDetail"
                @handleFullScreenForApproval="handleFullScreenForApproval" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowFullScreenForApproval=false">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="任务表单库"
            top="1vh"
            width="80%"
            :fullscreen=true
            :key="loadTimer" 
            append-to-body
            :visible.sync="isShowForms">
            <ProcessForms  :processInfo="processInfo" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowForms=false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="打印确认页"
            append-to-body
            top="4vh"
            :fullscreen=true
            :visible.sync="isShowPrintUtil">
            <PrintUtil :key="loadTimer" ref="printUtil" :formInfo="printForm"  />
        </el-dialog>

        <el-dialog
            class="popEditModelDetail"
            :fullscreen=true
            :visible.sync="isShowModelDetail"
            append-to-body>
            <ModelDetail
                :key="loadTimer"
                ref="modelDetailChild"
                :isShowCopyHis="true"
                :isShowForm="isShowFormDetail"
                :formInfo="formInfo"
                :taskInstance="taskInfo"
                :processModelFormsObj="processModelFormsObj"
                :processInstance="processInstance"
                @modelComplete="handleModelComplete"
                @setIsShowForm="setIsShowForm"/>
        </el-dialog>

        <el-dialog
            title="下一任务配置"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowNextTaskSetting">
            <ProcessSetting
                :processInstance="processInstance"
                :isNexTaskConfig="isNexTaskConfig"
                :taskList="nextTaskList"
                :archiveTemplateTreeList="archiveTemplateTreeList"
                @refreshProcessList="refreshNextTaskConfig"/>
        </el-dialog>

        <el-dialog
            :title="approvalTitle"
            width="80%"
            top="0vh"
            append-to-body
            class="approval-pop-dialog"
            :visible.sync="isShowApprovalPop"
            :fullscreen=true >
            <ApprovalPop :key="loadTimer" ref="approvalPop"
                :instances="{id:approvalInstanceId,formObj: {}}"
                :isInstance="false"
                :approvalTemplateObj="templateInfo"
                :busiProcessInstanceId="this.taskInfo.processInstanceId"
                :busiProcessInstanceName="this.taskInfo.processInstanceName"
                :busiTaskInstanceId="this.taskInfo.id"
                :belongProcessFlag="2"
                :formDataFromBusiness="approvalForm"
                :isFromProcessTaskForms="isFromProcessTaskForms"
                :processModelFormsObj="processModelFormsObj"
                :isDraft="true"
                :taskParam="taskParam" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleApply" :loading="startApprovalloading"  type="primary">发起审批</el-button>
                <el-button @click="isShowApprovalPop=false" type="info">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="流程模板"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowTemplateDiagram"
            custom-class="diagram-dialog">
            <ProcessDetailView ref="detailView" :viewParams="viewParams" />
        </el-dialog>

        <el-dialog
            class='processPopClass'
            title="启动流程"
            width="80%"
            top="0vh"
            append-to-body
            :visible.sync="isShowStartProcessDialog">
            <ProcessInstancePop :key="loadTimerProcess" ref="processInstancePop" :taskInfo="taskInfo" @refreshSubProcess="refreshSubProcess" @handleClosePop="handleClosePop"/>
        </el-dialog>

        <el-dialog
            title="主子流程关系图"
            :fullscreen=true
            :visible.sync="isShowProcessRelate"
            append-to-body >
            <ProcessRelateTree :key="loadTimer" ref="processRelateTree" :processInstanceId ="processInstance.id" />
        </el-dialog>

        <el-dialog
            title="选择待发送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCommentUserOrg"
            append-to-body >
            <UserOrg ref="userOrgExtComment" :multiple="true" :selectedUser="selectedCommentUser" :canDrop="true"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowCommentUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmCommontClick">确定发送</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="流程详情"
            top="4vh"
            width="75%"
            :visible.sync="isShowProcessDetail"
            append-to-body >
            <ProcessDetail ref="processDetail"
                :isFinish="false"
                :instances="instancesInfo"
                :isShowNewMode = "isNewPage"
                />
        </el-dialog>
        <el-dialog
            title="批量发起流程"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowStartProcessBatchAddDialog">
            <ProcessInstanceBatchAddPop :key="loadTimerProcess" ref="processInstanceBatchAddPop" :taskInfo="taskInfo" @handleClosePop="handleCloseBatchPop" />
        </el-dialog>
        <el-dialog
            title="表单数据选择"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowDataCopyDialog">
            <TableDataPop
                ref="tableDataPop"
                :modelId="currentModelId"
                @reloadFormData="reSetProcessFormData"
                >
            </TableDataPop>
        </el-dialog>
        <el-dialog
            title="历史表单数据选择"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowDataCloneDialog">
            <TableDataPop
                ref="tableDataPop1"
                :isUpdHis="true"
                :taskDefinitionKey="taskInfo.taskDefinitionKey" 
                :processServiceId="taskInfo.processServiceId"
                :modelId="currentModelId"
                :processInstanceId="taskInfo.processInstanceId"
                @reloadFormData="cloneHisTaskFormData"
                >
            </TableDataPop>
        </el-dialog>
        <el-dialog
            title="未还款的表单数据"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowDataFilterDialog">
            <TableDataPop
                ref="tableDataFilterPop"
                :key="loadTimer"
                :isApprovalFilter="true"
                :modelId="currentModelId"
                >
            </TableDataPop>
        </el-dialog>
        <el-dialog 
            width="95%"
            top="1vh"
            :fullscreen=true
            :visible.sync="activeProcess"
            append-to-body
            @close="hideEditDialog">
              <ModelDetail
                ref="modelInstanceProcess"
                :key="loadTimer"
                :isShowForm="isShowFormProcess"
                :resourceForm="true"
                :isRead="isProcessRead" 
                :formInfo="formInfoProcess"
                @modelComplete="handleModelCompleteProcess"
                @setIsShowForm="setIsShowFormProcess"
              />
        </el-dialog>
        <FieldValidation  ref="fieldValidation"/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Sidebox from '@/components/Sidebox';
    import { isEmpty, clone, cloneDeep } from 'lodash';
    import Comment from '../components/Comment';
    import TableDataPop from '@/components/TableDataPop';
    import ArchiveFilesList from '../components/ArchiveFilesTabs/ArchiveFilesList';
    // import ProcessDiagram from '@/pages/process/MyProcess/ProcessDiagram';
    import ProcessForms from '@/pages/process/MyProcess/ProcessForms';
    import WorkInstruction from '@/pages/process/ProcessEditor/components/WorkInstruction';
    import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
    import MyApproval from '@/pages/process/MyApproval';
    // import ProcessSetting from '@/pages/process/MyProcess/ProcessSetting';
    import { getPreviewFileUrl } from '@/utils/grocer';
    import { getTeamWorkModelInstanceId, getLastTaskApprovalInstanceIdByFromId, getApprovalInstanceDetail, getModelFormInstanceApprovalDurList, getTaskInstanceExecuteRecordBOList, getApprovalInstanceList, getApprovalTemplateByTaskFormData, getApprovalTemplateByFormData,
        getProcessInstanceTaskPkId, getExcelDataExportId, getModelListByMainFormId, getApprovalTemplateBOListByTaskId, getModelFormInstanceById,
        getProcessModelForms, getNextTaskNodeList, getProcessTaskCommentList, saveProcessTaskComment, getProcessInstanceTemplate, saveAppModelForm,
        deleteProcessTaskComment, getProcessInstancesDetail, getAllUserTask, getArchiveTemplateTreeList, sendApprovalCommentMsg, checkDataLegitimacy,
        getFormConfig, getModelFormReportList, checkReportRequired, getCrossFieldData, jumpTaskProcessInstances, involveUser, getCurrentUserInfo} from '@/data-model';
    import PrintUtil from '@/components/PrintUtil';
    import ApprovalTemplate from '@/pages/process/ProcessTemplate/ApprovalTemplate.vue';
    import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
    import FieldValidation from '@/components/Formula/FieldValidation.vue';
    // import ProcessInstancePop from '@/pages/process/ProcessTemplate/ProcessInstancePop.vue';
    import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
    import MyProcessListMode from '@/pages/process/MyProcess/MyProcessListMode';
    import SideLeftTree from '@/components/SideLeftTree';
    import mixinsNav from '@/mixins/mixins-nav';
    import { formatDate } from '@/utils/date.js';
    import { API_EXPORT_MODEL_FORM_EXCEL, API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID } from '@/common/constants';
    import { isFormFieldVisible, isRequiredFormFieldVisible, resetCascadeFieldVisible } from '@/utils/form-required';
    export default {
        mixins: [ mixinsNav ],
        components: {
            TableDataPop,
            Sidebox,
            Comment,
            ArchiveFilesList,
            WorkInstruction,
            // ProcessDiagram,
            MyApproval,
            ProcessForms,
            PrintUtil,
            ModelDetail,
            // ProcessSetting,
            ApprovalTemplate,
            ProcessDetailView,
            MyProcessListMode,
            SideLeftTree,
            RelateFormList,
            FieldValidation
            // ProcessInstancePop
        },
        data () {
            return {
                approvalLoading: false,
                isAssignee: false, // 是否是当前任务负责人
                approvalDetail: {}, // 当前表单的审批详情
                isShowDataFilterDialog: false,
                exportLoading: false,
                approvalInstanceList: [], // 当前任务的审批流
                hisDataList: [], // 用于存储引用的历史数据，两个属性formId、formDataId
                isShowDataCloneDialog: false,
                operateOpinionTxt: '',
                // 复制数据参数begin
                formIndex: 0, // 多表单时，用于重置表单数据
                currentModelId: '',
                currentFormId: '',
                isShowDataCopyDialog: false,
                // 复制数据参数end
                isShowStartProcessBatchAddDialog: false,
                canViewProcessDetail: false, // 是否可以查看流程详情
                instancesInfo: {},
                isShowProcessDetail: false,
                hideModeSwich: true,
                approvalTemplateList: [],
                isShowProcessRelate: false,
                isSubProcess: false,
                isNexTaskConfig: true,
                needConfigNextTask: false,
                isReloadNextTaskList: false,
                processInstance: {},
                nextTaskList: [],
                isShowNextTaskSetting: false,
                isShowTaskInfo: false,
                isCollapse: true,
                loadTimerFile: '',
                loadTimer: '',
                loadTimerUser: '',
                loadTimerField: '',
                loadTimerList: '',
                loadTimerProcess: '',
                isShowPrintUtil: false,
                isShowForms: false,
                isShowUserOrg: false,
                // isShowMyFile: false,
                isShowMyComment: false,
                isShowMyApproval: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                processInfo: {},
                tabName: 'first',
                tabPosition: 'top',
                isShowForm: false,
                collapseActiveName: '',
                formData: [],
                commentList: [],
                active: false, // 是否显示侧滑弹窗
                taskData: {},
                previewUrl: '',
                isShowPreview: false,
                isShowTransferAssigneeDialog: false,
                assigneeUser: '',
                btnConditions: [], // 任务变量
                isViewOperateOpinion: false,
                isOperateOpinionRequired: false,
                taskList: [],
                archiveTemplateTreeList: [],
                isShowDiagram: false,
                instances: {},
                isShowFullScreenForApproval: false,
                isFullScreenForApproval: false,
                selectedTemplate: [],
                selectedProcessTemplate: [],
                printForm: {},
                modelInstanceIds: '',
                isShowFormDetail: false,
                formInfo: {},
                isShowModelDetail: false,
                processModelFormsObj: [],
                isShowApprovalPop: false,
                approvalForm: {},
                canStartApproval: false,
                approvalInstanceId: '',
                approvalTitle: '发起审批',
                belongProcessFlag: 2,
                startApprovalloading: false,
                hasApplyUser: false,
                isFromProcessTaskForms: '1',
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    orderMode: 0,
                    rejectMode: 0,
                    sendSms: 0,
                    clearApprovalUsers: 0,
                    durTime: 0,
                    warnDate: '',
                    selectedCopyUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    }
                },
                taskParam: {},
                viewParams: {},
                isShowTemplateDiagram: false,
                isShowProcess: false,
                tableStyle: '',
                isShowStartProcessDialog: false,
                isShowCommentUserOrg: false,
                msgComment: {},
                selectedCommentUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                currentUserInfo: {},
                defaultViewOrder: null,
                isApprovalRefresh: false,
                mainId: '',
                tempFormData: [], // 将要新增的关联表单数据
                showRelateFormTab: false,
                relateFormTabName: '',
                loadTimerRelate: '',
                relateModelList: [], // 关联的表单
                initUserArr: [],
                isShowEditModelDetail: false,
                isShowFormProcess: false,
                isProcessRead: false,
                activeProcess: false,
                formInfoProcess: {},
                formBtnAuth: {// 表单按钮权限
                    isShowView: true, // 查看
                    isShowAdd: false, // 新增
                    isShowEdit: true, // 修改
                    isShowDelete: false, // 删除
                    isShowImport: false, // 导入
                    isShowExport: false, // 导出
                    isShowSyn: false// 同步流程数据
                },
                linkFieldCache: new Map(),
                searchParams: {
                    modelId: '',
                    name: '',
                    selectedFields: '',
                    searchCondition: []
                },
                searchCondition: [],
                defaultConditonsMap: new Map(), // 默认设置关联数据的过滤条件map
                searchConditionExt: [],
                canJumpTask: false,
                jumpTaskId: '',
                updAssignerTaskId: '',
                updAssignerUserId: ''
            };
        },
        filters: {
            ellipsis: function (value) {
                if (!value) return '';
                if (value.length > 30) {
                    return value.slice(0, 30) + '...';
                }
                return value;
            }
        },
        props: {
            taskInfo: {
                type: Object
            },
            isRead: {
                type: Boolean,
                default: false
            },
            tabId: {
                type: String,
                default: ''
            },
            isNewPage: {
                type: Boolean,
                default: false
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            forms () {
                if (isEmpty(this.taskInfo.formObj)) {
                    return [];
                } else {
                    // this.taskInfo.formObj.structure[0].fieldsList.forEach(element => {
                    //     // 处理权限字段
                    //     if (element.options && element.options.ext2) {
                    //         let curObj = JSON.parse(element.options.ext2);
                    //         if (curObj.formFieldAuthRange && curObj.formFieldAuthRange === 1) { // 查看权限在申请及审核阶段都生效
                    //             element.formFieldAuth = curObj.formFieldAuth;
                    //         }
                    //         element.approveFieldAuth = curObj.approveFieldAuth;
                    //     }
                    // });
                    return this.taskInfo.formObj.structure;
                }
            },
            completeBtns () {
                this.btnConditions = [];
                if (this.taskInfo.operations && this.taskInfo.operations.length > 0) {
                    this.taskInfo.operations.forEach(operation => {
                        if (operation.opinionType > 0) { // opinionType;// 按钮意见。0无需填写 1选填 2必填
                            // 显示意见输入框
                            this.isViewOperateOpinion = true;
                            if (operation.opinionType === 2) {
                                this.isOperateOpinionRequired = true;
                            }
                        }
                        if (operation.conditions && operation.conditions.length > 0) { // 任务节点变量列表
                            // 显示任务节点变量
                            this.btnConditions = this.btnConditions.concat(operation.conditions);
                        }
                    });
                }
                return this.taskInfo.operations;
            },
            ...mapGetters([
                'userInfo'
            ]),
            reportDormData () {
                return this.formData[0];
            }
        },
        watch: {
            'relateModelList' (newVal, oldVal) {
                if (newVal && newVal.length > 0) {
                    for (let i = 0; i < newVal.length; i++) {
                        let cur = newVal[i];
                        if (oldVal && oldVal.length > 0) {
                            let res = oldVal.find(element => element.id === cur.id);
                            if (res.hiddenElement) {
                                cur.hiddenElement = res.hiddenElement;
                            } else {
                                cur.hiddenElement = false;
                            }
                        }
                    }
                }
                if (this.relateModelList && this.relateModelList.length > 0) {
                    for (let i = 0; i < this.relateModelList.length; i++) {
                        let cur = this.relateModelList[i];
                        if (!cur.hiddenElement) {
                            this.relateFormTabName = cur.id;
                            break;
                        }
                    }
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                // if (this.forms && this.forms.length > 0) {
                //     let formInfo = this.forms[0];// 默认第一个
                //     if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                //         this.loadTimerField = new Date().getTime();
                //         for (var i = 0; i < formInfo.fieldsList.length; i++) {
                //             let tempField = formInfo.fieldsList[i];
                //             let tempRefName = 'fieldItemChild' + i;
                //             if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                //                 //this.isShowForm = true;// 20210520 jacky
                //                 setTimeout(() => {
                //                     // 设置下拉字段级联默认显示数据
                //                     if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                //                         this.$refs[tempRefName][0].initDefaultCasData();
                //                     }
                //                 }, 0);
                //             }
                //             if (!this.defaultViewOrder && tempField.type === 'subform') { // 用来显示默认第一个子表单
                //                 this.defaultViewOrder = i + '';
                //             }
                //             if (tempField.type === 'user') {
                //                 setTimeout(() => {
                //                 // 设置下拉字段级联默认显示数据
                //                     if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                //                         this.$refs[tempRefName][0].setUserExtCascadeData(true);
                //                     }
                //                 }, 0);
                //             }
                //         }
                //     }
                // }
                this.linkFieldCache = new Map();
                this.initFormPage();
                // 补充加载触发显示子表数据
                if (!this.relateModelList || this.relateModelList.length < 1) {
                    this.getModelListByMainFormId();
                } else {
                    this.showRelateFormTab = true;
                    // 默认打开第一个关联表单数据
                    this.relateFormTabName = this.relateModelList[0].id;
                    // console.log(this.relateModelList[0]);
                    this.renderModelFormList(this.relateModelList[0]);
                }
                window.sessionStorage.setItem('firstInitTaskDetailPage', true);
            });
        },
        async created () {
            // console.log(this.taskInfo);
            if (!this.taskInfo) {
                return;
            }
            // this.dealFromLinkCache();
            if (this.taskInfo.hasOwnProperty('operateOpinion')) {
                this.operateOpinionTxt = this.taskInfo.operateOpinion;
            }
            this._initFormData();
            this.setTaskParam();
            this.processTemplateList = [];
            // 流程信息，提供给所属流程字段使用
            this.processInstance.id = this.taskInfo.processInstanceId;
            this.processInstance.name = this.taskInfo.processInstanceName;
            if (!isEmpty(this.taskInfo.relationTaskInstanceId)) {
                this.isSubProcess = true;
            }
            this.getApprovalTemplateBOListByTaskId();

            // 跳转我的流程权限
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            try {
                this.currentUserInfo = await getCurrentUserInfo() || {};
                window.sessionStorage.setItem('currentUserInfo', JSON.stringify(this.currentUserInfo));
                window.localStorage.setItem('currentUserInfo', JSON.stringify(this.currentUserInfo));
            } catch (e) {
                this.currentUserInfo = currentUserStr ? JSON.parse(currentUserStr) : {};
            }
            let resources = this.currentUserInfo.resources;
            if (resources) {
                resources.forEach(item => {
                    // console.log(item.resourceDes);
                    if (item.resourceDes === 'process/myProcess/:processInstanceId') {
                        this.canViewProcessDetail = true;
                    }
                });
            }
            if (this.currentUserInfo.roleName === '任务超级管理员') {
                this.canJumpTask = true;
            }
            // 是否是当前任务负责人
            if (this.taskInfo.executor && this.currentUserInfo.userId === this.taskInfo.executor.assigneeUsers) {
                this.isAssignee = true;
            }
        },
        methods: {
            handleFromDataFilter (index, form) {
                this.loadTimer = new Date().getTime();
                this.currentModelId = form.modelId;
                this.isShowDataFilterDialog = true;
            },
            // 初始化表单结构
            async initFormPage () {
                if (this.forms && this.forms.length > 0) {
                    let formInfo = this.forms[0];// 默认第一个
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        resetCascadeFieldVisible(formInfo.fieldsList, this.formData[0].values);
                        this.loadTimerField = new Date().getTime();
                        // let initUserArr = [];
                        for (var i = 0; i < formInfo.fieldsList.length; i++) {
                            let tempField = formInfo.fieldsList[i];
                            let tempRefName = 'fieldItemChild' + i;
                            if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                                // this.isShowForm = true;// 20210520 jacky
                                setTimeout(() => {
                                    // 设置下拉字段级联默认显示数据
                                    if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                        this.$refs[tempRefName][0].initDefaultCasData();
                                    }
                                }, 0);
                            }
                            if (!this.defaultViewOrder && tempField.type === 'subform') { // 用来显示默认第一个子表单
                                this.defaultViewOrder = i + '';
                            }
                            if (tempField.type === 'user') {
                                this.initUserArr.push(tempRefName);
                            }
                        }
                    }
                }
                this.renderFormUserRef();
            },
            /** 自定义表单的配置信息，动态生产表单双向绑定所需的数据结构 */
            async _initFormData () {
                await this.setProcessModelFormsObj().then(async val => {
                    this.modelInstanceIds = '';
                    this.isShowProcess = false;
                    // 初始化业务流列表tab页签（解决点击任务表单后，业务流列表页签消失的bug）
                    if (this.taskInfo.taskNode && this.taskInfo.taskNode.isSubProcess === 1) {
                        this.isShowProcess = true;
                        this.selectedProcessTemplate = [];
                        if (!isEmpty(this.taskInfo.taskNode.subProcesslTemplateList)) {
                            this.selectedProcessTemplate = this.taskInfo.taskNode.subProcesslTemplateList;
                        }
                    }

                    let objTemporaryData = [];
                    // console.log(this.taskInfo);
                    if (this.taskInfo.formObj) {
                        objTemporaryData = this.taskInfo.formObj.instance === undefined ? [] : this.taskInfo.formObj.instance;
                    }
                    this.formData = [];
                    this.formData.length = 0;
                    // // 级联显示字段处理
                    // this.$nextTick(() => {
                    //     this.initFormPage();
                    // });
                    this.isShowForm = false;
                    if (this.forms && this.forms.length > 0) {
                        this.collapseActiveName = this.forms[0].id;// 默认打开第一个表单
                    }
                    if (objTemporaryData && Array.isArray(objTemporaryData)) {
                        let formValMap = new Map();
                        let parentValues = null;// 父流程里可能级联带出的表单数据
                        if (objTemporaryData) {
                            this.modelInstanceIds = '';
                            // 协同办公会签任务节点或多轮次暂存
                            let teamWorkDataMap = new Map();
                            let formSourceTaskMap = new Map();// k:表单id, v:当前节点允许读取数据的任务节点id
                            if (this.taskInfo.formObj && this.taskInfo.formObj.structure) {
                                this.taskInfo.formObj.structure.forEach(element => {
                                    teamWorkDataMap.set(element.teamWorkSourceTaskId, element);// k:当前任务表单关联的协同办公任务id, v：协同办公节点对应的表单id
                                    formSourceTaskMap.set(element.id, element.teamWorkFlag && element.teamWorkSourceTaskId ? element.teamWorkSourceTaskId : this.taskInfo.taskDefinitionKey);
                                });
                            }
                            objTemporaryData.forEach(taskForm => {
                                let objModelFormInstance = this._getTemporaryFormData(taskForm);
                                // console.log(objModelFormInstance);
                                if (taskForm.taskInstanceId === this.taskInfo.id && taskForm.modelIds) { // 当前任务的modelInstanceIds
                                    this.modelInstanceIds = taskForm.modelIds;
                                } else if (this.modelInstanceIds === '' && taskForm.modelInstanceIds) { // 首任务的modelInstanceIds
                                    this.modelInstanceIds = taskForm.modelInstanceIds;
                                }
                                if (objModelFormInstance) {
                                    let formModelMap = new Map();
                                    if (taskForm.modelIds) {
                                        let formModelObject = JSON.parse(taskForm.modelIds);
                                        for (var key in formModelObject) {
                                            formModelMap.set(key, formModelObject[key]);
                                        }
                                    }
                                    objModelFormInstance.forEach(form => {
                                        if (formSourceTaskMap.get(form.formId) !== taskForm.taskId) {
                                            return;
                                        }
                                        if (form.taskId !== taskForm.taskId) {
                                            let node = teamWorkDataMap.get(taskForm.taskId);
                                            // console.log(node);
                                            if (node && node.updHisProcessDataFlag === 1) { // 由于表单对应taskId不对，需要进行修改，读取的协同办公节点是引用历史数据的才修改
                                                form.taskId = taskForm.taskId;
                                            }
                                        }
                                        if (this.taskInfo.executor.modeType === 2) {
                                            if (this.taskInfo.isTeamWorkNode) { // 协同办公节点
                                                if (formModelMap.has(form.formId)) {
                                                    form.modelInstanceId = formModelMap.get(form.formId);
                                                }
                                                formValMap.set(form.formId, form);
                                            } else { // 非协同办公的会签任务表单
                                                if (taskForm.taskInstanceId === this.taskInfo.id) {
                                                    if (formModelMap.has(form.formId)) {
                                                        form.modelInstanceId = formModelMap.get(form.formId);
                                                    }
                                                    formValMap.set(form.formId, form);
                                                }
                                            }
                                        } else {
                                            if (formModelMap.has(form.formId)) {
                                                form.modelInstanceId = formModelMap.get(form.formId);
                                            }
                                            if (formValMap.has(form.formId)) {
                                                if (form.values.id && form.values.id === formModelMap.get(form.formId)) { // modelInstanceid是数据id的form才能用作数据渲染
                                                    formValMap.set(form.formId, form);
                                                }
                                                if (form.values.id && teamWorkDataMap.has(form.taskId)) { // edit by hezhen 2023-12-19
                                                    let node = teamWorkDataMap.get(form.taskId);
                                                    if (node.updHisProcessDataFlag === 1) { // 读取的协同办公节点是引用历史数据的才刷新
                                                        formValMap.set(form.formId, form);
                                                    }
                                                }
                                                if (form.values.id && this.taskInfo.taskNode.updHisProcessDataFlag === 1) { //  edit by hezhen 2023-12-19当前属于多轮次的引用历史数据任务节点 form.taskId === this.taskInfo.taskDefinitionKey
                                                    formValMap.set(form.formId, form);
                                                }
                                            } else {
                                                if (this.taskInfo.taskNode.updHisProcessDataFlag === 1 && form.taskId === this.taskInfo.taskDefinitionKey) { //  edit by hezhen 2023-12-19假如是修改历史的任务节点则只取当前表单最新轮次的数据
                                                    formValMap.set(form.formId, form);
                                                } else {
                                                    formValMap.set(form.formId, form);
                                                }
                                            }
                                            // console.log(cloneDeep(formValMap));
                                        }
                                    });
                                }
                            });
                            if (this.taskInfo.taskNode && this.taskInfo.taskNode.updHisProcessDataFlag !== 1 && this.processModelFormsObj) {
                                this.processModelFormsObj.forEach(taskFromObj => {
                                    if (!isEmpty(taskFromObj.definition)) {
                                    // 父流程任务里包含与当期任务节点相同的表单数据时，进行覆盖
                                        if (this.taskInfo.formObj && taskFromObj.definition[0].processServiceId !== this.taskInfo.processServiceId && taskFromObj.definition[0].formId === this.forms[0].id && this.taskInfo.relationTaskInstanceId && taskFromObj.instance && taskFromObj.modelInstanceIds) {
                                            let selectValues = JSON.parse(cloneDeep(taskFromObj.instance));
                                            parentValues = selectValues[0];
                                        // this.forms[0].isMatch = true;
                                        // this.refreshViewField();
                                        }
                                    }
                                });
                            }
                        }
                        // this.forms.forEach(async element => {
                        for (let findex = 0, totallen = this.forms.length; findex < totallen; findex++) {
                            let element = this.forms[findex];
                            let isMatch = false;
                            if (formValMap.has(element.id)) {
                                let tempData = formValMap.get(element.id);
                                if (this.taskInfo.executor.modeType !== 2) {
                                    // 重置协同办公表单数据（协同办公）
                                    // 协同表单、进行中的任务、不是修改历史
                                    if (element.teamWorkFlag && this.taskInfo.taskState === 1 && element.updHisProcessDataFlag === 0) {
                                        // 进行中的协同办公任务表单，重置下表单数据
                                        let modelInstanceIdMap = await getTeamWorkModelInstanceId({formId: element.id, processInstanceId: this.taskInfo.processInstanceId, taskInstanceId: this.taskInfo.id, taskDefinitionKey: this.taskInfo.taskDefinitionKey});
                                        // console.log(modelInstanceIdMap);
                                        if (modelInstanceIdMap && modelInstanceIdMap.modelInstanceId) {
                                            // console.log(modelInstanceIdMap.modelInstanceId);
                                            if (modelInstanceIdMap.modelFormInstance) {
                                                let valueJosn = JSON.parse(modelInstanceIdMap.modelFormInstance.formValues);
                                                tempData.values = valueJosn.values;
                                            }
                                            // console.log(modelInstanceIdMap.modelFormInstance.formValues);
                                        }
                                    }
                                }
                                tempData.taskId = element.taskId;
                                let fieldsList = element.fieldsList;
                                for (let index = 0, len = fieldsList.length; index < len; index++) {
                                    const element = fieldsList[index];
                                    if (fieldsList[index].type === 'category' && (tempData && tempData.attributes && !tempData.attributes.hasOwnProperty(element.id))) {
                                        tempData.values[element.id] = '';
                                        tempData.attributes[element.id] = element.type;
                                    }
                                }
                                if (tempData.hasOwnProperty('modelInstanceId') && tempData.modelInstanceId) {
                                    tempData.values.isOldData = true;
                                }
                                tempData.approvalStatusRecord = false;
                                // 查询该表单发起的最新的一条审批流的id信息
                                if (this.taskInfo.taskNode && this.taskInfo.taskNode.isApproval === 1) { // 任务为审批流节点
                                    let lastparam = {
                                        busiProcessInstanceId: this.taskInfo.processInstanceId,
                                        busiTaskInstanceId: this.taskInfo.id,
                                        taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                                        formId: element.id
                                    };
                                    let lastApprovalInfo = await getLastTaskApprovalInstanceIdByFromId(lastparam);
                                    if (lastApprovalInfo) {
                                        tempData.approvalInstanceId = lastApprovalInfo.approvalInstanceId;
                                        tempData.approvalRecordList = lastApprovalInfo.approvalRecordList;
                                        tempData.applyUserName = lastApprovalInfo.applyUserName;
                                        tempData.applyUserDept = lastApprovalInfo.applyUserDept;
                                        tempData.applyUserCreated = lastApprovalInfo.applyUserCreated;
                                        tempData.approvalStatusLabel = lastApprovalInfo.approvalStatusLabel;
                                    }
                                    // console.log(tempData);
                                }

                                tempData.values.approvalStatus = tempData.approvalStatus ? tempData.approvalStatus : '';
                                this.formData.push(tempData);
                                isMatch = true;
                            }
                            if (!isMatch) {
                                if (this.taskInfo.taskNode && this.taskInfo.taskNode.updHisProcessDataFlag !== 1 && parentValues) {
                                    this.formData.push(parentValues);
                                } else {
                                    this.renderdefaultForm(element);
                                }
                            }
                        // });
                        }
                        // console.log(this.formData);
                    } else {
                        this.forms.forEach(element => {
                            this.renderdefaultForm(element);
                        });
                    }
                    // await this.setProcessModelFormsObj();
                    // console.log(this.taskInfo);
                    // console.log(this.forms);
                    // if (this.taskInfo.taskNode && this.taskInfo.taskNode.isApproval === 1) {
                    //     this.canStartApproval = true;
                    //     // 是否可以重复发起审批流限制
                    //     if (this.taskInfo.taskNode.onlyOneApproval === 1) {
                    //         // 查询当前任务上的审批流
                    //         await this.getTaskApprovalInstanceList();
                    //         // 判断是否有正在进行中的、已通过的审批流，如果没有可以继续发起，否则不可。隐藏发起按钮
                    //         this.dealCanStartApprovalBtn(this.taskInfo.taskNode.approvalInstanceList);
                    //     }
                    // }
                    this.initCanStartApprovalBtn();
                    if (this.taskInfo.taskNode && this.taskInfo.taskNode.isApproval === 1 && ((this.tabId === '' && this.taskInfo.taskNode.cancelApprovalRemind !== 1) || this.tabId === 'sixth')) {
                        this.tabName = 'sixth';
                        this.isShowMyApproval = true;
                        this.getApprovalTemplateBOListByTaskId();// 查询任务节点上挂载的审批流模板
                        if (this.isAssignee && isEmpty(this.taskInfo.taskNode.approvalInstanceList)) {
                            this.$confirm('当前任务需要完成审批流程,是否马上发起申请?', '提示', {
                                confirmButtonText: '是',
                                cancelButtonText: '否',
                                type: 'warning',
                                center: true
                            }).then(() => {
                                // 发起申请
                                this.setTaskParam();
                                // this.loadTimer = new Date().getTime();
                                this.$refs.myApproval.handlePopApprovalTemplate();
                            }).catch(() => {
                                // 不做处理
                            });
                        }
                    } else if (this.taskInfo.taskNode && this.taskInfo.taskNode.isSubProcess === 1 && (this.tabId === '' || this.tabId === 'seventh')) {
                        this.tabName = 'seventh';
                        this.isShowProcess = true;
                        this.selectedProcessTemplate = [];
                        if (!isEmpty(this.taskInfo.taskNode.subProcesslTemplateList)) {
                            this.selectedProcessTemplate = this.taskInfo.taskNode.subProcesslTemplateList;
                        }
                    } else {
                        this.checkOpinionView();
                        if ((this.taskInfo.hasOwnProperty('formObj') && this.taskInfo.formObj.structure.length > 0) || this.btnConditions.length > 0 || this.isViewOperateOpinion) {
                            this.tabName = 'first';
                        } else {
                            this.loadTimerFile = new Date().getTime();
                            // this.isShowMyFile = true;
                            this.tabName = 'second';
                        }
                    }
                    this.isShowForm = true;
                    // 级联显示字段处理
                    this.$nextTick(() => {
                        this.initFormPage();
                    });
                    // if (this.isRead) {
                    //     setTimeout(() => {
                    //         this.$refs.myApproval.handleRefrenshApprovalList();
                    //     }, 0);
                    // }
                    this.loadTimerRelate = new Date().getTime();
                    await this.getModelListByMainFormId();
                    this.loadTimerField = new Date().getTime();
                    this.renderFormUserRef();
                });
            },
            async renderFormUserRef () {
                for (var j = 0; j < this.initUserArr.length; j++) { // 针对人员级联初始化
                    let tempRefName = this.initUserArr[j];
                    setTimeout(async () => {
                        // 设置下拉字段级联默认显示数据
                        if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                            await this.$refs[tempRefName][0].setUserExtCascadeData(true);
                        }
                    }, 10);
                }
            },
            async initCanStartApprovalBtn () {
                if (this.taskInfo.taskNode && this.taskInfo.taskNode.isApproval === 1) {
                    this.canStartApproval = true;
                    // 是否可以重复发起审批流限制
                    if (this.taskInfo.taskNode.onlyOneApproval === 1) {
                        // 查询当前任务上的审批流
                        await this.getTaskApprovalInstanceList();
                        // 判断是否有正在进行中的、已通过的审批流，如果没有可以继续发起，否则不可。隐藏发起按钮
                        this.dealCanStartApprovalBtn(this.approvalInstanceList);
                    }
                }
            },
            dealCanStartApprovalBtn (approvalInstanceList) {
                // 判断是否有正在进行中的、已通过的审批流，如果没有可以继续发起，否则不可
                if (approvalInstanceList && approvalInstanceList.length > 0) {
                    for (let i = 0; i < approvalInstanceList.length; i++) {
                        let item = approvalInstanceList[i];
                        if (item.approvalStatus === 1 || item.approvalStatus === 2) {
                            this.canStartApproval = false;
                            break;
                        } else if (item.approvalStatus === 3) {
                            let childList = item.children;
                            this.dealCanStartApprovalBtn(childList);
                        }
                    }
                }
            },
            // 构造发起审批时用于暂存的数据
            setTaskParam () {
                this.taskParam = {
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    updHisProcessDataFlag: this.taskInfo.taskNode.updHisProcessDataFlag,
                    btnConditions: this.btnConditions,
                    forms: this.formData,
                    modelInstanceIds: this.modelInstanceIds,
                    endDate: this.taskInfo.endDate,
                    taskState: this.taskInfo.taskState
                };
            },
            async setProcessModelFormsObj () {
                let processInstanceId = '';
                let deploymentId = '';
                if (this.taskInfo && this.taskInfo.processInstanceId) {
                    processInstanceId = this.taskInfo.processInstanceId;
                    deploymentId = this.taskInfo.processDefinitionDeploymentId;
                    let processTemplate = await getProcessInstanceTemplate(processInstanceId, this.taskInfo.processServiceId, deploymentId);
                    this.processModelFormsObj = await getProcessModelForms({
                        processInstanceId: processInstanceId,
                        deploymentId: deploymentId,
                        // 是否只查当前流程内的表单,假如配置了流程模板里任务自动完成，则可以不递归查询父流程表单，只查本流程内表单数据
                        onlyThis: !!(processTemplate && processTemplate.autoCompleteTask),
                        taskCallbackKey: this.taskInfo.taskCallbackKey
                    });
                }
            },
            checkOpinionView () {
                if (this.taskInfo.operations && this.taskInfo.operations.length > 0) {
                    this.taskInfo.operations.forEach(operation => {
                        if (operation.opinionType > 0) { // opinionType;// 按钮意见。0无需填写 1选填 2必填
                            // 显示意见输入框
                            this.isViewOperateOpinion = true;
                        }
                    });
                }
            },
            renderdefaultForm (element) {
                let fieldsList = element.fieldsList;
                let values = {};
                let attributes = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    values[element.id] = '';
                    attributes[element.id] = element.type;
                    let ext2 = element.options.ext2;
                    if (ext2) {
                        let curObj = JSON.parse(ext2);
                        element.formFieldAuth = curObj.formFieldAuth;
                        element.approveFieldAuth = curObj.approveFieldAuth;
                    }
                }
                this.formData.push({
                    approvalStatusRecord: false,
                    approvalInstanceId: '',
                    formId: element.id,
                    taskId: element.taskId,
                    values: values,
                    attributes: attributes,
                    colSpan: element.colSpan ? element.colSpan : 1,
                    ext1: element.ext1 ? Number(element.ext1) : 0
                });
            },
            getAttributes (source) {
                let attributes = {};
                source.forEach(element => {
                    let fieldsList = element.fieldsList;
                    for (let index = 0, len = fieldsList.length; index < len; index++) {
                        const element = fieldsList[index];
                        attributes[element.id] = element.type;
                    }
                });
                return attributes;
            },
            _getTemporaryFormData (formObj) {
                let temporaryFormData;
                if (formObj && formObj.instance) {
                    try {
                        let strTemporaryData = formObj.instance;
                        let objTemporaryData = JSON.parse(strTemporaryData);
                        temporaryFormData = objTemporaryData;
                    } catch (error) {
                        console.error('解析暂存的任务表单数据异常：', error);
                    }
                }

                return temporaryFormData;
            },
            handleTaskClaim () {
                this.$emit('taskClaim', { taskId: this.taskInfo.id });
            },
            convertCurrency (money) {
                // 汉字的数字
                // eslint-disable-next-line no-array-constructor
                var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
                // 基本单位
                // eslint-disable-next-line no-array-constructor
                var cnIntRadice = new Array('', '拾', '佰', '仟');
                // 对应整数部分扩展单位
                // eslint-disable-next-line no-array-constructor
                var cnIntUnits = new Array('', '万', '亿', '兆');
                // 对应小数部分单位
                // eslint-disable-next-line no-array-constructor
                var cnDecUnits = new Array('角', '分', '毫', '厘');
                // 整数金额时后面跟的字符
                var cnInteger = '整';
                // 整型完以后的单位
                var cnIntLast = '元';
                // 最大处理的数字
                var maxNum = 999999999999999.9999;
                // 金额整数部分
                var integerNum;
                // 金额小数部分
                var decimalNum;
                // 输出的中文金额字符串
                var chineseStr = '';
                // 分离金额后用的数组，预定义
                var parts;
                if (money == '') { return ''; }
                money = parseFloat(money);
                if (money >= maxNum) {
                // 超出最大处理数字
                    return '';
                }
                if (money == 0) {
                    chineseStr = cnNums[0] + cnIntLast + cnInteger;
                    return chineseStr;
                }
                // 转换为字符串
                money = money.toString();
                if (money.indexOf('.') == -1) {
                    integerNum = money;
                    decimalNum = '';
                } else {
                    parts = money.split('.');
                    integerNum = parts[0];
                    decimalNum = parts[1].substr(0, 4);
                }
                // 获取整型部分转换
                if (parseInt(integerNum, 10) > 0) {
                    var zeroCount = 0;
                    var IntLen = integerNum.length;
                    for (var i = 0; i < IntLen; i++) {
                        var n = integerNum.substr(i, 1);
                        var p = IntLen - i - 1;
                        var q = p / 4;
                        var m = p % 4;
                        if (n == '0') {
                            zeroCount++;
                        } else {
                            if (zeroCount > 0) {
                                chineseStr += cnNums[0];
                            }
                            // 归零
                            zeroCount = 0;
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                        }
                        if (m == 0 && zeroCount < 4) {
                            chineseStr += cnIntUnits[q];
                        }
                    }
                    chineseStr += cnIntLast;
                }
                // 小数部分
                if (decimalNum != '') {
                    var decLen = decimalNum.length;
                    for (var i = 0; i < decLen; i++) {
                        var n = decimalNum.substr(i, 1);
                        if (n != '0') {
                            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                        }
                    }
                }
                if (chineseStr == '') {
                    chineseStr += cnNums[0] + cnIntLast + cnInteger;
                } else if (decimalNum == '') {
                    chineseStr += cnInteger;
                }
                return chineseStr;
            },
            handleTaskCompleteConfirm (btn) {
                // console.log(btn);
                // let isNotValid = true;
                this.$confirm('您确定要对当前任务执行【' + btn.operateName + '】操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (ret) => {
                    this.handleTaskCompletePre(btn);
                }).catch(() => {
                    return false;
                });
            },
            dealFieldValue (field, values) {
                if (field.type === 'text') {
                    if (field.options.upMoneyField) { // 配置了金额大写
                        let upMoneyId = field.options.upMoneyField;
                        let res = this.convertCurrency(values[upMoneyId]);
                        values[field.id] = res;
                    }
                } else if (field.type === 'date') {
                    if (field.options.lastDateView && field.isView && !field.isRead) {
                        let dateTimeValueformat = 'yyyy-MM-dd hh:mm:ss';
                        let dateValueformat = 'yyyy-MM-dd';
                        if (field.options.config.type === 'dateTime' && !isEmpty(field.options.ext3)) {
                            if (field.options.ext3 === '1') { // 时分
                                dateTimeValueformat = 'yyyy-MM-dd hh:mm';
                            } else if (field.options.ext3 === '2') { // 时
                                dateTimeValueformat = 'yyyy-MM-dd hh';
                            }
                        }
                        if (field.options.config.type === 'date' && !isEmpty(field.options.ext3)) {
                            if (field.options.ext3 === '1') { // 年月
                                dateValueformat = 'yyyy-MM';
                            } else if (this.field.options.ext3 === '2') { // 年
                                dateValueformat = 'yyyy';
                            }
                        }
                        // if (field.options.lastDateView && isEmpty(this.formData[this.field.formField])) {
                        let lastDateView = formatDate(new Date(), (field.options.config.type === 'dateTime' ? dateTimeValueformat : dateValueformat));
                        values[field.id] = lastDateView;
                    }
                }
                return values;
            },
            async handleTaskCompletePre (btn) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let similarityBo = {warnFlag: false, similarity: 0}; // 相识度对象
                for (let i = 0; i < this.forms.length; i++) {
                    let values = this.formData[i].values;
                    let formId = this.formData[i].formId;
                    let modelId = this.forms[i].modelId;
                    let fieldsList = this.forms[i].fieldsList;
                    // console.log(btn.deploymentId);
                    fieldsList.forEach(field => {
                        if (field.type === 'text') {
                            if (field.options.upMoneyField) { // 配置了金额大写
                                let upMoneyId = field.options.upMoneyField;
                                let res = this.convertCurrency(values[upMoneyId]);
                                values[field.id] = res;
                            }
                        }
                        if (btn.deploymentId == '5079808') {
                            if (field.name == '项目负责人审核发现的问题意见附件' ||
                            field.name == '一次审核修改情况附件' ||
                            field.name == '一审修改验证情况' ||
                            // field.name == '二次审核发现的问题意见附件' ||
                            field.name == '二次审核修改情况附件' ||
                            // field.name == '二审修改验证情况' ||
                            // field.name == '三次审核发现的问题意见附件' ||
                            field.name == '三次审核修改情况附件'
                            // field.name == '三审修改验证情况'
                            ) {
                                btn[field.id] = values[field.id];
                                // console.log(field.name + '=======' + values[field.id] + '=========='+field.id);
                            }
                        }

                        values = this.dealFieldValue(field, values);
                    });
                    let param = {values: values, formId: formId, modelId: modelId, modelType: 0};
                    param.isUpdateProcess = '0';
                    if (this.hisDataList && this.hisDataList.length > 0) {
                        for (let j = 0; j < this.hisDataList.length; j++) {
                            let cur = this.hisDataList[j];
                            if (cur.formId === formId) {
                                param.isUpdateProcess = '1';
                            }
                        }
                    }
                    param.processInstanceId = this.taskInfo.processInstanceId;
                    let res = await checkDataLegitimacy(param);
                    if (res.state !== 'success') {
                        if (res.msg) {
                            this.$message.error(res.msg);
                        } else {
                            this.$message.error('数据不合法');
                        }
                        loading.close();
                        return true;
                    } else {
                        // console.log(this.forms[i]);
                        // console.log(this.formData[i].values);
                        // console.log(this.taskInfo);
                        // 非协同表单、进行中的任务、非修改历史任务
                        if (!this.forms[i].teamWorkFlag && this.taskInfo.taskState === 1 && this.taskInfo.taskNode.updHisProcessDataFlag === 0) {
                            if (res.warnFlag) { // 多表单，只要有一个表单预警，则就提醒
                                similarityBo.warnFlag = res.warnFlag;
                                similarityBo.similarity = res.similarity;
                            }
                        }
                    }
                }
                // console.log(btn.deploymentId);
                if (btn.deploymentId == '5079808') { // 如果是报告三级审核的流程,额外判断必填项
                    let res = await checkReportRequired(btn);
                    // console.log(res);
                    if (res.state == 'error') {
                        this.$message.error(res.msg);
                        loading.close();
                        return;
                    }
                }
                try {
                    if (similarityBo.warnFlag) {
                        this.$confirm('与系统中已有的数据相似度达【' + similarityBo.similarity + '%】,是否继续完成任务？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (ret) => {
                            this.needNextTaskConfig().then(val => {
                                if (this.needConfigNextTask) {
                                    this.$confirm('下一任务尚未配置负责人，是否要马上配置负责人?', '提示', {
                                        confirmButtonText: '是',
                                        cancelButtonText: '否',
                                        type: 'warning',
                                        center: true
                                    }).then(async () => {
                                        // 弹出配置负责人框
                                        this.processInstance = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                                        this.isShowNextTaskSetting = true;
                                    }).catch(() => {
                                        // 继续执行
                                        this.handleTaskComplete(btn);
                                    });
                                } else {
                                    this.handleTaskComplete(btn);
                                }
                            });
                            loading.close();
                        }).catch(() => {
                            loading.close();
                            return false;
                        });
                    } else {
                        this.needNextTaskConfig().then(val => {
                            if (this.needConfigNextTask) {
                                this.$confirm('下一任务尚未配置负责人，是否要马上配置负责人?', '提示', {
                                    confirmButtonText: '是',
                                    cancelButtonText: '否',
                                    type: 'warning',
                                    center: true
                                }).then(async () => {
                                    // 弹出配置负责人框
                                    this.processInstance = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                                    this.isShowNextTaskSetting = true;
                                }).catch(() => {
                                    // 继续执行
                                    this.handleTaskComplete(btn);
                                });
                            } else {
                                this.handleTaskComplete(btn);
                            }
                        });
                        loading.close();
                    }
                } catch (error) {
                    loading.close();
                }
            },
            setFormValue (btn) {
                let btnName = btn.operateName;
                if (this.forms && this.forms.length > 0) {
                    // 1、选出表单结构中设置了同步任务按钮属性的的下拉字段
                    for (let i = 0, len = this.forms.length; i < len; i++) {
                        let formInfo = this.forms[i];
                        let formFieldList = formInfo.fieldsList;
                        formFieldList.forEach(field => {
                            if (field.type === 'select') { // 暂时支持下拉
                                if (field.options.synTaskBtnState) { // 需要同步
                                    // 2、将按钮字段写入对应的字段值里
                                    if (this.formData && this.formData.length > 0) {
                                        for (let i = 0, len = this.formData.length; i < len; i++) {
                                            let curformData = this.formData[i];
                                            if (curformData.formId === formInfo.id) {
                                                // 3、找到与按钮名称一样的下拉值
                                                if (field.options.config && field.options.config.options) {
                                                    let isShow = true;
                                                    if (this.formData[i].values.hasOwnProperty(field.id + '-casDefautShow')) {
                                                        isShow = this.formData[i].values[field.id + '-casDefautShow'];
                                                    }
                                                    if (isShow) { // only sync visible fields
                                                        field.options.config.options.forEach(item => {
                                                            if (item.title === btnName) {
                                                                // 4、将该值写入表单value
                                                                this.formData[i].values[field.id] = item.value;
                                                                this.formData[i].values[field.id + '-view'] = item.title;
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            },
            async chkOtherRequiredField () {
                let isNotValid = false;
                let formRequireFieldList = {};
                for (let dIndex = 0; dIndex < this.formData.length; dIndex++) {
                    let fData = this.formData[dIndex];
                    for (var findex = 0; findex < this.forms.length; findex++) {
                        let formInfo = this.forms[findex];
                        // 流水号保存生成字段渲染
                        if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                            let requireArray = [];
                            for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                let field = formInfo.fieldsList[fieldIndex];
                                if (field.type === 'subform' && field.isView && isFormFieldVisible(field, fData.values)) { // 校验子表单必填项
                                    if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                        this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                        return true;
                                    } else { // 子表单有值，需要验证子表单内的必填项
                                        let subFlag = false;
                                        let sonFieldList = field.options.fieldList;
                                        let fieldNames = [];
                                        for (let i = 0; i < sonFieldList.length; i++) {
                                            let cur = sonFieldList[i];
                                            if (cur.options.required) { // 有必填项
                                                for (let i = 0; i < fData.values[field.formField].length; i++) {
                                                    let curObj = fData.values[field.formField][i];
                                                    if (!isFormFieldVisible(cur, curObj)) {
                                                        continue;
                                                    }
                                                    let curValue = curObj[cur.id];
                                                    if (!curValue) { // 有值
                                                        subFlag = true;
                                                        fieldNames.push(cur.label);
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        if (subFlag) {
                                            this.$message({message: field.name + '中的' + fieldNames.join(',') + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                            return true;
                                        }
                                    }
                                } else if (isRequiredFormFieldVisible(field, fData.values) && (field.type === 'file' || field.type === 'category' || field.type === 'link')) {
                                    if (!fData.values[field.id] || fData.values[field.id] === '') {
                                        this.verifySpecialField(field.id);
                                        this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                        return true;
                                    }
                                } else if (field.type === 'archive' && field.isView && isFormFieldVisible(field, fData.values)) {
                                    if (field.options.required && field.options.config.type === 'multi' && !fData.values[field.formField + '-archiveId']) {
                                        this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                        return true;
                                    }
                                } else if (field.type === 'text' && field.isView && isFormFieldVisible(field, fData.values)) {
                                    if (field.options.ext1) { // 超链接字段
                                        if (field.options.required && fData.values[field.id].length < 1) {
                                            this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                            return true;
                                        }
                                    }
                                }
                                if ((field.type === 'text' || field.type === 'user' || field.type === 'select' || field.type === 'number') && isFormFieldVisible(field, fData.values)) {
                                    if (field.isView && field.options.required) { // 当前字段是必填项
                                        requireArray.push(field.id);
                                    } else {
                                        if (isRequiredFormFieldVisible(field, fData.values)) { // 当前字段是必填项
                                            requireArray.push(field.id);
                                        }
                                    }
                                }
                            }
                            let formId = formInfo.id;
                            if (formId) {
                                formRequireFieldList[formId] = requireArray;
                                fData['requireFieldArray'] = requireArray;
                            }
                        }
                    }
                }
                return isNotValid;
            },
            dkqrRequiredRuleSetting (index) { // 中兴华咨到款确认单个性化必填规则  edit by hezhen 2024-04-16
                let fData = this.formData[index];
                if (fData) {
                    // 根据【到款所属】字段选择：总部 3BA41102    分公司  E396B234
                    let dkss = fData.values['b62938e3de1a4fccb945e68de0959617'];
                    if (dkss === '3BA41102') { // 1.总部   ->  收款公示 必填，  发票 不必填
                        // this.$refs['customForm0'][0].clearValidate('b21967a4cc74493496c84351c86570d7');// 发票
                        let skgg = fData.values['729df5c59e1847828c93e5a2e042fd03'];// 收款公示
                        if (!skgg) {
                            this.$message({message: '【关联预收公示】是必填项，请填写信息!', type: 'warning', duration: 1500});
                            return true;
                        }
                    } else if (dkss === 'E396B234') { // 2.分公司 ->  收款公示 不必填  发票必填
                        let dklx = fData.values['8d7d2124abd34e84a016141bdbc3bcc6']; // 到款类型 已立项到款 9245D31D
                        if (dklx === '9245D31D') { // 只有已立项到款才进行发票单的必填项约束 20240710
                        // this.$refs['customForm0'][0].clearValidate('729df5c59e1847828c93e5a2e042fd03');// 收款公示
                            let fp = fData.values['b21967a4cc74493496c84351c86570d7'];// 发票
                            if (!fp) {
                                this.$message({message: '【关联发票单】是必填项，请填写信息!', type: 'warning', duration: 1500});
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            async handleTaskComplete (btn) {
                let operateType = btn.operateType;
                this.setFormValue(btn);
                let isNotValid = false;
                // 完成任务操作，需要校验表单，但驳回操作，则不需要校验表单了
                if (operateType !== '9' && operateType !== '3') {
                    for (let i = 0, len = this.forms.length; i < len; i++) {
                        if (this.dkqrRequiredRuleSetting(i)) {
                            return false;
                        }
                        this.$refs['customForm' + i][0].validate((valid) => {
                            if (!valid && !this.formData[i].values.isOldData) {
                                isNotValid = true;
                                this.messageTip('表单录入数据校验不通过，请修改后再操作', 'warning');
                                return false;
                            }
                        });
                    }
                }
                // 校验特殊自定义字段 驳回操作，则不需要校验表单了
                if (operateType !== '3' && operateType !== '9') {
                    let chkFlg = await this.chkOtherRequiredField();
                    if (chkFlg) {
                        return false;
                    }
                }
                if (!isEmpty(this.btnConditions)) {
                    let flg = false;
                    this.btnConditions.forEach(btnCondition => {
                        if (isEmpty(btnCondition.varVal)) {
                            flg = true;
                            return false;
                        }
                    });
                    if (flg) {
                        this.$message({message: '请输入条件值', type: 'warning'});
                        return false;
                    }
                }
                if (this.isOperateOpinionRequired && isEmpty(this.operateOpinionTxt)) {
                    this.$message({message: '请输入审批意见', type: 'warning'});
                    return false;
                }
                if (!isNotValid) {
                    isNotValid = await this.checkNumberRule();// 校验数字类型字段
                    if (isNotValid) {
                        return false;
                    }
                    let param = {
                        operateOpinion: this.operateOpinionTxt === '' ? btn.operateName : this.operateOpinionTxt,
                        operateType,
                        btnConditions: this.btnConditions,
                        // operateOpinion: this.operateOpinion,
                        forms: this.formData,
                        modelInstanceIds: this.getModelInstanceIds()
                    };
                    if (this.taskInfo.taskNode && this.taskInfo.taskNode.updHisProcessDataFlag === 1) { // 属于修改历史数据
                        // console.log(param.modelInstanceIds);
                        //  为空或者任务的关联表单数据为空{ca30c42ea23b4f2181c87bea4cba9d19: ""}
                        let isFirst = false;
                        if (!isEmpty(param.modelInstanceIds) && this.forms && this.forms.length > 0) {
                            for (let i = 0; i < this.forms.length; i++) {
                                let formId = this.formData[i].formId;
                                if (isEmpty(param.modelInstanceIds[formId])) {
                                    isFirst = true;
                                    break;
                                }
                            }
                        } else {
                            isFirst = true;
                        }
                        if (isFirst) {
                            // 属于驳回后再次要完成的任务
                            let completeParam = {
                                processInstanceId: this.taskInfo.processInstanceId,
                                id: this.taskInfo.taskDefinitionKey
                            };
                            let finishedTasklist = await getTaskInstanceExecuteRecordBOList(completeParam);
                            let tempJson = null;
                            if (finishedTasklist && finishedTasklist.length > 0) {
                                if (this.forms && this.forms.length > 0) {
                                    for (let i = 0; i < this.forms.length; i++) {
                                        let values = this.formData[i].values;
                                        let formId = this.formData[i].formId;
                                        if (tempJson === null) {
                                            tempJson = {};
                                        }
                                        if (isEmpty(values.id)) {
                                            this.$message.error('该任务节点为修改历史数据任务，请从历史数据中选择任务表单数据');
                                            return true;
                                        }
                                        tempJson[formId] = values.id;
                                    }
                                    param.modelInstanceIds = tempJson;
                                }
                            } else {
                                this.$message.error('该任务节点为修改历史数据任务，请从历史数据中选择任务表单数据');
                                return true;
                            }
                        }
                    }

                    if (this.forms && this.forms.length > 0 && operateType !== '9' && operateType !== '3') { // 驳回操作，不需要校验主子表单了
                    // if (this.forms && this.forms.length > 0) {
                        // console.log(this.formData[0].values);
                        if (this.formData[0].values && !this.formData[0].values.id) {
                            if (this.forms[0].relateModelRequired && (this.relateModelList && this.relateModelList.length > 0)) {
                                if (this.forms[0].id === '727d0cd345484dda86a130f566d61081') { // 中泽的合同信息表
                                    // console.log(this.formData[0]);
                                    // 获取合同类型的值
                                    let itemValue = this.formData[0].values['8661037efcce49048b8e5d8c13356ef6'];
                                    // 项目合同DEE500FA、业务结算合同97CDC0E0
                                    if (itemValue === 'DEE500FA' || itemValue === '97CDC0E0') {
                                        if (this.tempFormData.length === 0) {
                                            this.$message({message: '关联子表是必填项，尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                            return false;
                                        } else { // 多个关联子表，每个子表都需要校验是否有值了
                                            for (let k = 0; k < this.relateModelList.length; k++) {
                                                let relateModel = this.relateModelList[k];
                                                for (let j = 0; j < this.tempFormData.length; j++) {
                                                    let relateFormData = this.tempFormData[j];
                                                    if (relateFormData.formId === relateModel.formId) {
                                                        relateModel.hasData = true;
                                                        break;
                                                    }
                                                }
                                                if (relateModel.hasData) {
                                                    continue;
                                                } else {
                                                    this.$message({message: '关联子表【' + relateModel.modelName + '】尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    // 关联子表必填校验
                                    if (this.tempFormData.length === 0) {
                                        this.$message({message: '关联子表是必填项，尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                        return false;
                                    } else { // 多个关联子表，每个子表都需要校验是否有值了
                                        for (let k = 0; k < this.relateModelList.length; k++) {
                                            let relateModel = this.relateModelList[k];
                                            for (let j = 0; j < this.tempFormData.length; j++) {
                                                let relateFormData = this.tempFormData[j];
                                                if (relateFormData.formId === relateModel.formId) {
                                                    relateModel.hasData = true;
                                                    break;
                                                }
                                            }
                                            if (relateModel.hasData) {
                                                continue;
                                            } else {
                                                this.$message({message: '关联子表【' + relateModel.modelName + '】尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                                return false;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        param.mainModelInfo = {formId: this.forms[0].id, modelId: this.forms[0].modelId, tempFormData: this.tempFormData}; // 多表单情况暂时只支持第一个表单有主子表单结构
                    }
                    // console.log(param);
                    // console.log(this.relateModelList);
                    // console.log(this.modelInstanceIds);
                    if (this.modelInstanceIds && this.modelInstanceIds !== '') {
                        param.mainDataModelInstanceIds = JSON.parse(this.modelInstanceIds);
                    }
                    param.operateName = btn.operateName;
                    this.$emit('taskComplete', param);
                    // this.getModelInstanceIds();
                }
            },
            async checkNumberRule () { // 校验数字类型字段
                let isRefuse = false;
                if (this.forms && this.formData && this.forms.length > 0 && this.formData.length > 0) {
                    for (var dIndex = 0; dIndex < this.formData.length; dIndex++) {
                        let fData = this.formData[dIndex];
                        for (var findex = 0; findex < this.forms.length; findex++) {
                            let formInfo = this.forms[findex];
                            // 检查数字类型校验
                            let resObj = await this.$refs.fieldValidation.validateNumberRule(formInfo.fieldsList, fData.values);
                            if (resObj.isRefuse) {
                                let tempRefName = resObj.tempRefName;
                                let tempRefKey = resObj.tempRefKey;
                                if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                    this.$refs[tempRefName][0].fieldFocus(tempRefKey);
                                }
                                this.$message({message: '表单字段校验失败!' + resObj.refuseInfo, type: 'warning', duration: 3000});
                                isRefuse = true;
                                break;
                            }
                            await this.dealSelRuleSetting(formInfo.fieldsList, fData.values);// 设置级联赋值逻辑
                        }
                    }
                }
                return isRefuse;
            },
            async dealSelRuleSetting (fieldsList, formValues) { // 根据表单数据规则设置设置下拉或选项类型字段的选中值
                let fieldsMap = new Map();
                let fieldRuleMap = new Map();// 字段规则map
                let fieldSelKVMap = new Map();
                if (fieldsList && Array.isArray(fieldsList)) {
                    for (var index = 0; index < fieldsList.length; index++) {
                        let field = fieldsList[index];
                        fieldsMap.set(field.id, field);
                        if (field.type === 'select' || (field.type === 'category' && field.options.config.type === 'single')) {
                            for (let k = 0; k < field.options.config.options.length; k++) {
                                let item = field.options.config.options[k];
                                if (isEmpty(item.assignmentFieldId) && !isEmpty(item.assignmentFieldValue)) { // key为空，值不为空
                                    fieldRuleMap.set(item.value, item.assignmentFieldValue);
                                    fieldSelKVMap.set(item.value, field.id);
                                }
                            }
                        }
                    }
                }
                if (fieldRuleMap.size > 0) {
                    let tansgerFieldRuleMap = new Map();// 字段规则map
                    for (let fieldIndex = 0; fieldIndex < fieldsList.length; fieldIndex++) {
                        let field = fieldsList[fieldIndex];
                        fieldRuleMap.forEach(function (value, key) {
                            if (value && value.indexOf(field.name) !== -1) {
                                let tempVal = '';
                                if (tansgerFieldRuleMap.has(key)) {
                                    tempVal = tansgerFieldRuleMap.get(key);
                                    tempVal = tempVal.replace(field.name, field.id);
                                } else {
                                    tempVal = value.replace(field.name, field.id);
                                }
                                tansgerFieldRuleMap.set(key, tempVal);
                            }
                        });
                    }
                    let finalArr = [];
                    tansgerFieldRuleMap.forEach(function (value, key) {
                        finalArr.push({key: key, value: value});
                    });
                    for (let i = 0; i < finalArr.length; i++) {
                        let obj = finalArr[i];
                        let result = await this.$refs.fieldValidation.chkPassRule(null, obj.value.trim(), formValues, fieldsMap, null);
                        // console.log(result);
                        if (result) {
                            formValues[fieldSelKVMap.get(obj.key)] = obj.key;
                        }
                    }
                }
            },
            getModelInstanceIds () {
                let modelInstanceIds = '';
                let parentModelInstanceIds = null;// 父流程里的表单数据
                let formModelRelationMap = new Map();
                let taskRoundMap = new Map();
                let roundRecordMap = new Map();// 记录当前轮次是否需要新增数据
                let round = 1;// 流程发起轮次，被驳回或回退后
                let currentProcessModelFormsMap = new Map();
                // console.log(this.processModelFormsObj);
                if (this.processModelFormsObj) {
                    let currentProcessModelFormsObj = this.taskInfo.hasOwnProperty('formObj') && this.taskInfo.formObj ? this.taskInfo.formObj.instance : [];
                    currentProcessModelFormsObj.forEach(modelFormsObj => {
                        if (modelFormsObj.hasOwnProperty('taskInstanceId')) { // 假如有数据，记录当前任务的实例id
                            currentProcessModelFormsMap.set(modelFormsObj.taskInstanceId, modelFormsObj.taskInstanceId);
                        }
                    });
                    this.processModelFormsObj.forEach(taskFromObj => {
                        if (!isEmpty(taskFromObj.definition)) {
                            if (currentProcessModelFormsMap.size > 0 && taskFromObj.hasOwnProperty('taskInstanceId') && !currentProcessModelFormsMap.has(taskFromObj.taskInstanceId)) {
                                // console.log(taskFromObj); 当前流程以外的任务表单
                            } else {
                                if (taskRoundMap.has(taskFromObj.definition[0].taskId)) { // 设置任务轮次
                                    round = taskRoundMap.get(taskFromObj.definition[0].taskId) + 1;
                                    taskRoundMap.set(taskFromObj.definition[0].taskId, round);
                                } else {
                                    taskRoundMap.set(taskFromObj.definition[0].taskId, round);
                                }
                                if (roundRecordMap.has(round)) {
                                    roundRecordMap.set(round, roundRecordMap.get(round) + 1);
                                } else {
                                    roundRecordMap.set(round, 1);
                                }
                                if (taskFromObj.hasOwnProperty('modelInstanceIds') && !isEmpty(taskFromObj.modelInstanceIds)) { // 假如有数据，记录当前任务的数据
                                    let jsonObj = JSON.parse(taskFromObj.modelInstanceIds);
                                    for (var key in jsonObj) {
                                        formModelRelationMap.set(key, jsonObj[key]);
                                    }
                                }
                            }
                            // 父流程任务里包含与当期任务节点相同的表单数据时，进行覆盖
                            if (this.taskInfo.formObj && taskFromObj.definition[0].processServiceId !== this.taskInfo.processServiceId && taskFromObj.definition[0].formId === this.forms[0].id && this.taskInfo.relationTaskInstanceId && taskFromObj.instance && taskFromObj.modelInstanceIds) {
                                parentModelInstanceIds = taskFromObj.modelInstanceIds;
                            }
                        }
                    });
                }
                // 协同办公会签任务节点或多轮次暂存
                let teamWorkDataMap = new Map();
                let tempModelInstanceIds = null;
                if (this.taskInfo.formObj && this.taskInfo.formObj.structure) {
                    this.taskInfo.formObj.structure.forEach(element => {
                        teamWorkDataMap.set(element.teamWorkSourceTaskId, element.id);// k:当前任务表单关联的协同办公任务id, v：协同办公节点对应的表单id
                    });
                }
                if ((this.taskInfo.executor.modeType === 2 && this.taskInfo.isTeamWorkNode) || roundRecordMap.get(taskRoundMap.get(this.taskInfo.taskDefinitionKey)) > 1) {
                    let tempJson = null;
                    if (this.taskInfo.hasOwnProperty('formObj') && this.taskInfo.formObj.structure && this.taskInfo.formObj.structure.length > 0) {
                        this.taskInfo.formObj.structure.forEach(fromStructure => {
                            if (formModelRelationMap.has(fromStructure.id)) { // 假如有数据，记录当前任务的数据
                                if (tempJson === null) {
                                    tempJson = {};
                                }
                                tempJson[fromStructure.id] = formModelRelationMap.get(fromStructure.id);
                            } else {
                                if (tempJson === null) {
                                    tempJson = {};
                                }
                                tempJson[fromStructure.id] = '';
                            }
                        });
                        modelInstanceIds = tempJson;
                        this.taskInfo.formObj.instance.forEach(element => { // 取出协同办公最原始的instance节点
                            if (teamWorkDataMap.has(element.taskId)) {
                                tempModelInstanceIds = element.modelInstanceIds;
                            }
                        });
                        if (tempModelInstanceIds) {
                            let jsonObj = JSON.parse(tempModelInstanceIds);
                            for (let prop in modelInstanceIds) { // 假如此处的modelInstanceIds和后端返回的不一致，则已后端返回的为准
                                if (modelInstanceIds[prop] !== jsonObj[prop]) {
                                    let newModelInstanceId = modelInstanceIds[prop];
                                    modelInstanceIds[newModelInstanceId] = jsonObj[prop];
                                }
                            }
                        }
                    }
                } else if (roundRecordMap.get(taskRoundMap.get(this.taskInfo.taskDefinitionKey)) === 1) {
                    if (this.taskInfo.hasOwnProperty('formObj') && this.taskInfo.formObj.instance && this.taskInfo.formObj.instance.length > 0) {
                        this.taskInfo.formObj.instance.forEach(instance => {
                            if (instance.taskId === this.taskInfo.taskDefinitionKey) { // 假如有数据，记录当前任务的数据
                                modelInstanceIds = instance.hasOwnProperty('modelIds') ? JSON.parse(instance.modelIds) : '';
                            }
                            if (teamWorkDataMap.has(instance.taskId)) {
                                tempModelInstanceIds = instance.modelIds;
                            }
                        });
                        if (modelInstanceIds === '' && tempModelInstanceIds) {
                            modelInstanceIds = tempModelInstanceIds;
                        }
                    }
                }
                // 有引用数据，则更新modelInstanceIds
                if (this.hisDataList && this.hisDataList.length > 0) {
                    let tempModelJson = null;
                    for (let i = 0; i < this.hisDataList.length; i++) {
                        let item = this.hisDataList[i];
                        let formId = item.formId;
                        let formDataId = item.formDataId;
                        if (modelInstanceIds === null || modelInstanceIds === '') {
                            tempModelJson = {};
                            tempModelJson[formId] = formDataId;
                        } else {
                            modelInstanceIds[formId] = formDataId;
                        }
                    }
                    if (tempModelJson != null) {
                        modelInstanceIds = tempModelJson;
                    }
                }
                // console.log('=======');
                if (this.taskInfo.taskNode && this.taskInfo.taskNode.updHisProcessDataFlag !== 1 && parentModelInstanceIds) {
                    modelInstanceIds = parentModelInstanceIds;
                }
                return modelInstanceIds;
            },
            handleTaskDelete () {
                this.$emit('taskDelete', { taskId: this.taskInfo.id });
            },
            handleTaskHidden () {
                this.$emit('taskHidden', { taskId: this.taskInfo.id });
            },
            async handleTaskTemporarySave () {
                let isNotValid = false;
                for (let i = 0, len = this.forms.length; i < len; i++) {
                    this.$refs['customForm' + i][0].validate((valid) => {
                        if (!valid) {
                            isNotValid = true;
                            this.messageTip('表单录入数据校验不通过，请修改后再操作', 'warning');
                            return false;
                        }
                    });
                }
                // 校验特殊自定义字段
                // if (this.chkOtherRequiredField()) { // 暂存不校验必填项
                //     return false;
                // }
                isNotValid = await this.checkNumberRule();// 校验数字类型字段
                if (!isNotValid) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    for (let i = 0; i < this.forms.length; i++) {
                        let values = this.formData[i].values;
                        let formId = this.formData[i].formId;
                        let modelId = this.forms[i].modelId;
                        let fieldsList = this.forms[i].fieldsList;
                        fieldsList.forEach(field => {
                            // if (field.type === 'text') {
                            //     if (field.options.upMoneyField) { // 配置了金额大写
                            //         let upMoneyId = field.options.upMoneyField;
                            //         let res = this.convertCurrency(values[upMoneyId]);
                            //         values[field.id] = res;
                            //     }
                            // }
                            values = this.dealFieldValue(field, values);
                        });
                        let param = {values: values, formId: formId, modelId: modelId, modelType: 0};
                        param.processInstanceId = this.taskInfo.processInstanceId;
                        let res = await checkDataLegitimacy(param);
                        if (res.state !== 'success') {
                            if (res.msg) {
                                this.$message.error(res.msg);
                            } else {
                                this.$message.error('数据不合法');
                            }
                            loading.close();
                            return true;
                        }
                    }
                    loading.close();
                    let param = {
                        operateOpinion: this.operateOpinionTxt,
                        btnConditions: this.btnConditions,
                        forms: this.formData,
                        modelInstanceIds: this.getModelInstanceIds(),
                        mainModelInfo: {formId: this.forms[0].id, modelId: this.forms[0].modelId, tempFormData: this.tempFormData} // 多表单情况暂时只支持第一个表单有主子表单结构
                    };

                    if (this.taskInfo.taskNode && this.taskInfo.taskNode.updHisProcessDataFlag === 1) { // 属于修改历史数据
                        if (isEmpty(param.modelInstanceIds)) {
                            // 属于驳回后再次要完成的任务
                            let completeParam = {
                                processInstanceId: this.taskInfo.processInstanceId,
                                id: this.taskInfo.taskDefinitionKey
                            };
                            let finishedTasklist = await getTaskInstanceExecuteRecordBOList(completeParam);
                            // console.log(finishedTasklist);
                            let tempJson = null;
                            if (finishedTasklist && finishedTasklist.length > 0) {
                                if (this.forms && this.forms.length > 0) {
                                    for (let i = 0; i < this.forms.length; i++) {
                                        let values = this.formData[i].values;
                                        let formId = this.formData[i].formId;
                                        if (tempJson === null) {
                                            tempJson = {};
                                        }
                                        if (isEmpty(values.id)) {
                                            this.$message.error('该任务节点为修改历史数据任务，请从历史数据中选择任务表单数据');
                                            return true;
                                        }
                                        tempJson[formId] = values.id;
                                    }
                                    param.modelInstanceIds = tempJson;
                                }
                            } else {
                                this.$message.error('该任务节点为修改历史数据任务，请从历史数据中选择任务表单数据');
                                return true;
                            }
                        }
                    }

                    this.$emit('taskTemporarySave', param);
                }
            },
            handleTaskRevoke () {
                this.$emit('taskRevoke', { });
            },
            // 判断是否需要设置下一个任务负责人
            async needNextTaskConfig () {
                this.needConfigNextTask = false;
                if (this.taskInfo.showNextUserTaskConfigBtn) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    try {
                        this.nextTaskList = await getNextTaskNodeList({
                            taskId: this.taskInfo.id,
                            processInstanceId: this.taskInfo.processInstanceId,
                            processServiceId: this.taskInfo.processServiceId,
                            deploymentId: this.taskInfo.processDefinitionDeploymentId
                        });
                    } catch (error) {
                        console.error('接口调用异常：', error);
                    } finally {
                        loading.close();
                    }
                    if (this.nextTaskList && this.nextTaskList.length > 0) {
                        for (var i = 0; i < this.nextTaskList.length; i++) {
                            let item = clone(this.nextTaskList[i]);
                            // 常规任务下一任务
                            if (item.executor.modeType === 0 && isEmpty(item.executor.assigneeUsers)) { // 下一任务有任务没有设置负责人
                                this.needConfigNextTask = true;
                            }
                        }
                    } else {
                        this.needConfigNextTask = false;
                    }
                } else {
                    this.needConfigNextTask = false;
                }
            },
            async handleNextTaskConfig () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.nextTaskList = await getNextTaskNodeList({
                    taskId: this.taskInfo.id,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId
                });
                loading.close();
                if (this.nextTaskList && this.nextTaskList.length > 0) {
                    this.processInstance = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                    this.isShowNextTaskSetting = true;
                } else {
                    this.$message({message: '没有下一任务了', type: 'warning'});
                    return false;
                }
            },
            async getApprovalTemplateBOListByTaskId () {
                let param = {
                    taskId: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId
                };
                this.approvalTemplateList = await getApprovalTemplateBOListByTaskId(param);
                this.selectedTemplate = this.approvalTemplateList;
            },
            async refreshNextTaskConfig (isReloadNextTaskList) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.nextTaskList = await getNextTaskNodeList({
                    taskId: this.taskInfo.id,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId
                });
                let treeList = [];
                if (this.processInstance.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                loading.close();

                this.isReloadNextTaskList = isReloadNextTaskList;
                this.processInstance = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                this.isShowNextTaskSetting = true;
            },
            async getCommentList () {
                if (this.taskInfo) {
                    let { data } = await getProcessTaskCommentList({
                        taskInstanceId: this.taskInfo.id,
                        processInstanceId: this.taskInfo.processInstanceId
                    });
                    this.commentList = data;
                }
            },
            async handleCommentAdd (comment) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await saveProcessTaskComment({
                    taskInstanceId: this.taskInfo.id,
                    processInstanceId: this.taskInfo.processInstanceId,
                    comments: comment.content,
                    texts: comment.text,
                    mainId: comment.mainId,
                    supId: comment.supId
                });
                await this.getCommentList();
                loading.close();
            },
            async handleCommentDelete (comment) {
                await deleteProcessTaskComment(comment.id);
                await this.getCommentList();
            },
            async handleViewComment () {
                await this.getCommentList();
                this.active = true;
            },
            async confirmCommontClick () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$refs.userOrgExtComment.setChoosedUser();
                this.msgComment.supId = this.selectedCommentUser.selectedUserIds + ';' + this.selectedCommentUser.selectedUserNames;
                this.msgComment.mainId = this.taskInfo.name;
                this.msgComment.isDelete = 3;// 1:审批流，2：流程，3：任务
                await sendApprovalCommentMsg(this.msgComment);
                loading.close();
                this.isShowCommentUserOrg = false;
            },
            chooseCommentUser (comment) {
                this.selectedCommentUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.msgComment = comment;
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExtComment._initPage();
                }, 0);
                this.isShowCommentUserOrg = true;
            },
            hideSidebox () {
                this.active = false;
            },
            async handleTabClick (tab, event) {
                if (tab.name === 'second') {
                    this.loadTimerFile = new Date().getTime();
                    // this.isShowMyFile = true;
                    // setTimeout(() => {
                    //     this.$refs.processFiles._initPage();
                    // }, 0);
                } else if (tab.name === 'third') {
                    this.isShowMyComment = true;
                    this.getCommentList();
                } else if (tab.name === 'sixth') {
                    this.isShowMyApproval = true;
                    this.loadTimer = new Date().getTime();
                }
                if (tab.name !== 'fifth') {
                    this.isShowPreview = false;
                }
                if (tab.name === 'first') {
                    this.initCanStartApprovalBtn();
                    let param = {taskId: '', tabId: ''};
                    param.taskId = this.taskInfo.id;
                    param.tabId = 'first';
                    if (this.isApprovalRefresh) {
                        this.isApprovalRefresh = false;
                        this.$emit('refreshTaskDetail', param);
                    }
                }
                if (tab.name === 'seventh') {
                    this.isShowProcess = true;
                }
            },
            async handlePrint (index) {
                this.loadTimer = new Date().getTime();
                this.printForm = this.formData[index];
                this.printForm.fieldsList = this.forms[index].fieldsList;
                this.printForm.formName = this.forms[index].formName;
                this.printForm.printTemplate = this.forms[index].printTemplate;
                if (!isEmpty(this.printForm.printTemplate)) {
                    let lastparam = {
                        busiProcessInstanceId: this.taskInfo.processInstanceId,
                        busiTaskInstanceId: this.taskInfo.id,
                        taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                        formId: this.formData[index].formId
                    };
                    let lastApprovalInfo = await getLastTaskApprovalInstanceIdByFromId(lastparam);
                    if (lastApprovalInfo) {
                        this.printForm.approvalRecordList = lastApprovalInfo.approvalRecordList;
                    }
                    this.printForm.applyUserName = this.formData[index].applyUserName;
                    this.printForm.applyUserDept = this.formData[index].applyUserDept;
                    this.printForm.applyUserCreated = this.formData[index].applyUserCreated;
                    this.printForm.approvalStatus = this.formData[index].approvalStatusLabel;
                }
                // console.log(this.printForm);
                this.dealPrintStr();
                this.isShowPrintUtil = true;
            },
            // 打印模板拼装
            dealPrintStr () {
                if (!isEmpty(this.printForm.printTemplate)) {
                    // 1、子表单占位符处理
                    this.printForm.printTemplate = this.printForm.printTemplate.replaceAll('\r', '').replaceAll('\n', '');
                    // console.log(this.printForm.values);
                    // 获取打印模板中的子表单字段
                    // 提取以{开头,以}结尾的中间部分字符串的正则表达式：(?<={).*?(?=(}|$))/ig
                    let elementReg = /(?<={).*?(?=(}|$))/ig;
                    let elements = this.printForm.printTemplate.match(elementReg);
                    let fieldsList = this.printForm.fieldsList;
                    let subElements = [];
                    elements.forEach(item => {
                        for (let index = 0, len = fieldsList.length; index < len; index++) {
                            let fieldObj = fieldsList[index];
                            if (fieldObj.id === item) {
                                let type = fieldObj.type;
                                if (type === 'subform') {
                                    subElements.push(fieldObj);
                                }
                                break;
                            }
                        }
                    });
                    // 子表单字段数据替换、拼接
                    if (subElements.length > 0) {
                        let sourceData = this.printForm.values;
                        // 提取以@Sub开头,以Sub@结尾的中间部分字符串的正则表达式
                        let subFormStrReg = /(?<=@Sub).*?(?=(Sub@|$))/ig;
                        let subFormStrArr = this.printForm.printTemplate.match(subFormStrReg); // 子表单打印模板字符串list
                        for (let i = 0; i < subElements.length; i++) {
                            let subFormField = subElements[i];
                            // 替换子表单名
                            this.printForm.printTemplate = this.printForm.printTemplate.replace('{' + subFormField.id + '}', subFormField.name);
                            // 子表单打印模板
                            // <tr height="60px"><td>{11fd5298335a4cd18b125b689a99f552}</td><td>{a79bf19398024a2b985e7e452829eb7b}</td><td>{435c5c6efd684ca08eaa9d3910a0070f}</td><td>{4d3d281931bc40f8a14523ece5946723}人民币(大写):{d2557de3cd724c4097bfcca37a256510}</td><td>{03f90ff6cbc84997a50f3e849d404a15}</td><td>{03f90ff6cbc84997a50f3e849d404a15}</td></tr>
                            let subFormTr = clone(subFormStrArr[i]);
                            // 子表单打印模板中的字段占位符
                            let subFormElements = subFormTr.match(elementReg);
                            // console.log(subFormTr);
                            // 子表单数据list
                            let subFormData = sourceData[subFormField.id];
                            // console.log(subFormData);

                            // 替换后的子表单打印模板数据
                            let subFormDataPrint = [];
                            if (subFormData && subFormData.length > 0) {
                                subFormData.forEach(subFormDataItemStr => {
                                    let subFormTrItem = clone(subFormTr);
                                    let subFieldsList = subFormField.options.fieldList;// 子表单的所有字段
                                    subFormElements.forEach(item => {
                                        let sourceValue = ''; // 从源数据中拉出来的字段值
                                        let sourceContent = '{' + item + '}'; // 占位符
                                        for (let index = 0, len = subFieldsList.length; index < len; index++) {
                                            let fieldObj = subFieldsList[index];
                                            if (fieldObj.id === item) {
                                                let type = fieldObj.type;
                                                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                                                    // -tree
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-tree'];
                                                } else if (type === 'user') {
                                                    // -user
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-user'];
                                                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                                                    // -view
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-view'];
                                                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date' || type === 'subFormSummary') {
                                                    sourceValue = subFormDataItemStr[fieldObj.id];
                                                } else if (type === 'link') {
                                                    sourceValue = subFormDataItemStr[fieldObj.id + '-view'];
                                                }
                                                break;
                                            }
                                        }
                                        if (sourceValue === undefined) {
                                            sourceValue = '';
                                        }
                                        subFormTrItem = subFormTrItem.replaceAll(sourceContent, sourceValue);
                                    });
                                    subFormDataPrint.push(subFormTrItem);
                                });
                            }
                            // 替换后的最终的子表单数据
                            let subFormDataPrintStr = '';
                            for (let index = 0; index < subFormDataPrint.length; index++) {
                                subFormDataPrintStr = subFormDataPrintStr + subFormDataPrint[index];
                            }
                            // 替换到总打印模板里
                            this.printForm.printTemplate = this.printForm.printTemplate.replaceAll('@Sub' + subFormTr + 'Sub@', subFormDataPrintStr);
                            // console.log(this.printForm.printTemplate);
                        }
                    }

                    // 2、表单字段占位符替换处理
                    // console.log(this.printForm.values);
                    // 提取以{开头,以}结尾的中间部分字符串的正则表达式：(?<={).*?(?=(}|$))/ig
                    // let elementReg = /(?<={).*?(?=(}|$))/ig;
                    // let elements = this.printForm.printTemplate.match(elementReg);
                    // console.log(elements);
                    if (!isEmpty(elements)) {
                        let sourceData = this.printForm.values;
                        let fieldsList = this.printForm.fieldsList;
                        elements.forEach(item => {
                            let sourceValue = ''; // 从源数据中拉出来的字段值
                            let sourceContent = '{' + item + '}'; // 占位符
                            for (let index = 0, len = fieldsList.length; index < len; index++) {
                                let fieldObj = fieldsList[index];
                                if (fieldObj.id === item) {
                                    let type = fieldObj.type;
                                    if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                                        // -tree
                                        sourceValue = sourceData[fieldObj.id + '-tree'];
                                    } else if (type === 'user') {
                                        // -user
                                        sourceValue = sourceData[fieldObj.id + '-user'];
                                    } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                                        // -view
                                        sourceValue = sourceData[fieldObj.id + '-view'];
                                    } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date' || type === 'subFormSummary') {
                                        sourceValue = sourceData[fieldObj.id];
                                    } else if (type === 'link') {
                                        sourceValue = sourceData[fieldObj.id + '-view'];
                                    } else if (type === 'subform') {
                                        sourceValue = sourceData[fieldObj.id];
                                    }
                                    break;
                                }
                            }
                            if (sourceValue === undefined) {
                                sourceValue = '';
                            }
                            this.printForm.printTemplate = this.printForm.printTemplate.replaceAll(sourceContent, sourceValue);
                        });
                    }
                }
            },
            async getTaskApprovalInstanceList () {
                let param = {
                    approvalStatus: 15, // 当前任务上申请的
                    busiProcessInstanceId: this.taskInfo.processInstanceId,
                    busiTaskInstanceId: this.taskInfo.id,
                    state: null,
                    isOther: false,
                    isCopyFlag: 0
                };
                if (isEmpty(this.approvalInstanceList)) {
                    let formData = await getApprovalInstanceList(Object.assign({}, {
                        currentPage: 1,
                        pageSize: 100
                    }, param));
                    if (formData) {
                        this.approvalInstanceList = formData.data;
                    }
                }
            },
            checkRequireFormData (obj) { // 国融评协报备审核必填项校验
                let jsonObj = obj.values;
                let htwtxx = jsonObj['0dad6f64ecaa4a7fb30efb5bd60d5685'];// 合同委托信息
                if (!jsonObj['575d10ed70f14a8386145bd1c5f9f6d2']) { // 框架协议类型
                    this.$message.error('框架协议类型未选择');
                    return false;
                } else if (!jsonObj['9a0a9779840e4108beb22e392512d29b']) { // 业务类型(合同)
                    this.$message.error('业务类型(合同)未选择');
                    return false;
                } else if (!jsonObj['6c2041e1ccfa43228e4f2f97d515ceb9']) { // 币种
                    this.$message.error('币种未选择');
                    return false;
                } else if (!jsonObj['ad6ba8ef60f5498f802cfcb2fe4ffefd']) { // 约定的服务费是否确定
                    this.$message.error('约定的服务费是否确定未选择');
                    return false;
                } else if (!jsonObj['39f22aa91c5b4fd992e52801b9789db2']) { // 评估目的/经济行为
                    this.$message.error('评估目的/经济行为未选择');
                    return false;
                } else if (!jsonObj['9ff22251811e44ea843c093ae36fd7ac']) { // 评估目的/经济行为描述
                    this.$message.error('评估目的/经济行为描述未填写');
                    return false;
                } else if (!jsonObj['aa6c7a8050934346a9386734c3afdd7b']) { // 具体评估目的(合同)
                    this.$message.error('具体评估目的(合同)未填写');
                    return false;
                } else if (!htwtxx) { // 合同委托信息
                    this.$message.error('合同委托信息未填写');
                    return false;
                } else {
                    let htwtxxObj = htwtxx[0];
                    if (!htwtxxObj['05d88e2a5e524a52a82a69628e8b38c2']) { // 委托人性质
                        this.$message.error('委托人性质未选择');
                        return false;
                    } else if (!htwtxxObj['9066c7900b734c688e8a8a3874695ba2']) { // 委托人代码
                        this.$message.error('委托人代码未填写');
                        return false;
                    } else if (!htwtxxObj['cdf1cdcffe7f4695ab28d1db463febe8']) { // 委托人名称
                        this.$message.error('委托人名称未填写');
                        return false;
                    } else if (!htwtxxObj['59002af0934c4bfba53dc95d6e1b1d2e']) { // 所在省市
                        this.$message.error('委托人所在省市未选择');
                        return false;
                    } else if (!htwtxxObj['d240f97fa211483192a080200f27ac5b']) { // 地区详情
                        this.$message.error('委托人地区详情未填写');
                        return false;
                    }
                    if (htwtxxObj['9066c7900b734c688e8a8a3874695ba2'] && htwtxxObj['9066c7900b734c688e8a8a3874695ba2'].length !== 18) {
                        this.$message.error('委托人代码格式不正确，应为18为字符');
                        return false;
                    }
                }
                // 报告必填项校验
                if (!jsonObj['e279ba0d3fb843569420994ef749648a']) { // 报告类型
                    this.$message.error('报告类型未选择');
                    return false;
                } else if (!jsonObj['1923c5f4e2c1466aacffe4cad4a54eaf']) { // 报告子类
                    this.$message.error('报告子类未选择');
                    return false;
                } else if (!jsonObj['e755af521d1047a8a415be89ce9025d8']) { // 评估目的/经济行为
                    this.$message.error('评估目的/经济行为(报告信息)未选择');
                    return false;
                } else if (!jsonObj['083be272517a4afcb5795bc4c88c0552']) { // 具体评估目的
                    this.$message.error('具体评估目的未填写');
                    return false;
                } else if (!jsonObj['775224ba3ad7466d9bdd04c4edb2b4dc']) { // 评估(咨询)对象
                    this.$message.error('评估(咨询)对象未选择');
                    return false;
                } else if (!jsonObj['612c4b21fde14ef3b4f2e5ec38ced477']) { // 评估(咨询)对象子类
                    this.$message.error('评估(咨询)对象子类未选择');
                    return false;
                } else if (!jsonObj['a24b4b172cf340cbb8d3cdb33369254f']) { // 价值类型
                    this.$message.error('价值类型未选择');
                    return false;
                } else if (!jsonObj['87216a8b2465422293149cc1fecc5ea5']) { // 价值类型其他描述
                    this.$message.error('价值类型其他描述未填写');
                    return false;
                } else if (!jsonObj['ae84e5f4783f4845bb1677ceca88293a']) { // 国家监管部门
                    this.$message.error('国家监管部门未选择');
                    return false;
                }
                return true;
            },
            async handleStartApproval (index) {
                if (this.formData[index].formId === '08cf7d614d294208bfc42049b4e396c5') { // 国融评协报备审核必填项校验
                    let res = this.checkRequireFormData(this.formData[index]);
                    if (!res) {
                        return;
                    }
                }
                // 中泽，借款表单发起审批，校验是否有到期未结清的借款
                let values = this.formData[index].values;
                if (values['26689e30b998426a85679c247bbe44f3'] !== 'C4AE131C' && values['26689e30b998426a85679c247bbe44f3'] !== 'E5F31105') {
                    let durlist = await getModelFormInstanceApprovalDurList({'formId': this.formData[index].formId});
                    // console.log(durlist);
                    if (durlist && durlist.length > 0) {
                        this.$message({message: '尚有未结清的借款审批!', type: 'warning', duration: 1500});
                        return;
                    }
                }
    
                // 是否可以重复发起审批流限制
                if (this.taskInfo.taskNode.onlyOneApproval === 1) {
                    if (this.taskInfo.endDate) { // 任务已完成就不进行约束了，保留后续可以发起审批的口子

                    } else { // 查询当前任务上的审批流
                        await this.getTaskApprovalInstanceList();
                        // 判断是否有正在进行中的、已通过的审批流，如果没有可以继续发起，否则不可
                        this.dealCanStartApprovalBtn(this.approvalInstanceList);
                        if (!this.canStartApproval) {
                            this.$message.error('当前任务不可重复发起审批!');
                            return false;
                        }
                    }
                }
                this.loadTimer = new Date().getTime();
                this.approvalForm = this.formData[index];
                // 国融兴华个性化需求begin
                if (this.formData[index].formId === '613087a8672244aca9758ffa766635cc') { // (国融兴华)[业务承接表单]发起审批流
                    let flg = false;
                    this.$refs['customForm' + index][0].validate((valid) => {
                        if (valid) {
                            flg = true;
                        } else {
                            flg = false;
                        }
                    });
                    if (flg) {
                        // 字段内唯一性校验
                        let values = this.formData[index].values;
                        let formId = this.formData[index].formId;
                        let modelId = this.forms[index].modelId;
                        let param1 = {values: values, formId: formId, modelId: modelId, modelType: 0};
                        param1.processInstanceId = this.taskInfo.processInstanceId;
                        let res = await checkDataLegitimacy(param1);
                        if (res.state !== 'success') {
                            if (res.msg) {
                                this.$message.error(res.msg);
                            } else {
                                this.$message.error('数据不合法');
                            }
                            return false;
                        }

                        // getApprovalTemplateByFormData
                        let param = {
                            formId: this.formData[index].formId,
                            formValue: this.formData[index].values
                        };
                        let curTemplate = await getApprovalTemplateByFormData(param);
                        if (curTemplate) {
                            this.templateInfo = cloneDeep(curTemplate);
                            this.approvalTitle = '发起【' + this.templateInfo.templateName + '】审批申请';
                            this.templateInfo.remarks = '';
                            this.templateInfo.selectedUser = {};
                            if (!isEmpty(this.templateInfo.selectedUserIds)) {
                                this.templateInfo.selectedUser.selectedUserIds = this.templateInfo.selectedUserIds;
                                this.templateInfo.selectedUser.selectedUserNames = this.templateInfo.selectedUserNames;
                            } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                                this.templateInfo.selectedUser.selectedUserIds = '';
                                this.templateInfo.selectedUser.selectedUserNames = '';
                            }
                            this.setTaskParam();
                            this.approvalInstanceId = this.generateUUID();
                            setTimeout(() => { // 默认回显值
                                this.$refs.approvalPop._initPage();
                            }, 0);
                            this.isShowApprovalPop = true;
                        } else {
                            this.$message.error('找不到该表单相匹配的审批流模板，请联系管理员处理!');
                        }
                    } else {
                        this.$message({message: '表单数据校验不通过，请修改信息!', type: 'warning', duration: 1500});
                    }
                    // 国融兴华个性化需求end
                } else {
                    // console.log(this.approvalForm);
                    let hasTemplateCnt = 0;
                    let similarityBo = {warnFlag: false, similarity: 0}; // 相识度对象
                    if (this.taskInfo.taskNode && this.taskInfo.taskNode.isApproval === 1) {
                        // console.log(this.approvalTemplateList);
                        if (!isEmpty(this.approvalTemplateList)) {
                            if (this.taskInfo.taskNode.formApprovalFlag === 1) {
                                let flg = false;
                                this.$refs['customForm' + index][0].validate((valid) => {
                                    if (valid) {
                                        flg = true;
                                    } else {
                                        flg = false;
                                    }
                                });
                                if (flg) {
                                    // 字段内唯一性校验
                                    let values = this.formData[index].values;
                                    let formId = this.formData[index].formId;
                                    let modelId = this.forms[index].modelId;
                                    let param1 = {values: values, formId: formId, modelId: modelId, modelType: 0};
                                    param1.processInstanceId = this.taskInfo.processInstanceId;
                                    let res = await checkDataLegitimacy(param1);
                                    if (res.state !== 'success') {
                                        if (res.msg) {
                                            this.$message.error(res.msg);
                                        } else {
                                            this.$message.error('数据不合法');
                                        }
                                        return false;
                                    } else {
                                        similarityBo.warnFlag = res.warnFlag;
                                        similarityBo.similarity = res.similarity;
                                    }

                                    let param = {
                                        processInstanceId: this.taskInfo.processInstanceId,
                                        taskId: this.taskInfo.taskDefinitionKey,
                                        formId: this.formData[index].formId,
                                        formValue: this.formData[index].values
                                    };
                                    let curTemplate = await getApprovalTemplateByTaskFormData(param);
                                    // console.log(curTemplate);
                                    if (curTemplate) { // 根据选项值找到对应的关联审批流模板
                                        for (let i = 0; i < this.approvalTemplateList.length; i++) {
                                            let templateInfo = this.approvalTemplateList[i];
                                            if (templateInfo.id === curTemplate.id) {
                                                this.templateInfo = templateInfo;
                                                hasTemplateCnt = 1;
                                                break;
                                            }
                                        }
                                    } else { // 没有找到选项值的关联模板
                                        // 查找到只含有这个表单的模板
                                        for (let i = 0; i < this.approvalTemplateList.length; i++) {
                                            let templateInfo = this.approvalTemplateList[i];
                                            if (templateInfo.dataOperate.forms && templateInfo.dataOperate.forms.length == 1 && templateInfo.dataOperate.forms[0].formId === this.approvalForm.formId) {
                                                this.templateInfo = this.approvalTemplateList[i];
                                                hasTemplateCnt = hasTemplateCnt + 1;
                                            }
                                        }
                                    }
                                } else {
                                    this.$message({message: '表单数据校验不通过，请修改信息!', type: 'warning', duration: 1500});
                                    return false;
                                }
                            } else {
                                let flg = false;
                                this.$refs['customForm' + index][0].validate((valid) => {
                                    if (valid) {
                                        flg = true;
                                    } else {
                                        flg = false;
                                    }
                                });
                                if (flg) {
                                    // 字段内唯一性校验
                                    let values = this.formData[index].values;
                                    let formId = this.formData[index].formId;
                                    let modelId = this.forms[index].modelId;
                                    let param1 = {values: values, formId: formId, modelId: modelId, modelType: 0};
                                    param1.processInstanceId = this.taskInfo.processInstanceId;
                                    let res = await checkDataLegitimacy(param1);
                                    if (res.state !== 'success') {
                                        if (res.msg) {
                                            this.$message.error(res.msg);
                                        } else {
                                            this.$message.error('数据不合法');
                                        }
                                        return false;
                                    } else {
                                        similarityBo.warnFlag = res.warnFlag;
                                        similarityBo.similarity = res.similarity;
                                    }
                                    // 查找到只含有这个表单的模板
                                    for (let i = 0; i < this.approvalTemplateList.length; i++) {
                                        let templateInfo = this.approvalTemplateList[i];
                                        if (templateInfo.dataOperate.forms && templateInfo.dataOperate.forms.length == 1 && templateInfo.dataOperate.forms[0].formId === this.approvalForm.formId) {
                                            this.templateInfo = this.approvalTemplateList[i];
                                            hasTemplateCnt = hasTemplateCnt + 1;
                                        }
                                    }
                                }
                            }
                            // // 查找到只含有这个表单的模板
                            // for (var i = 0; i < this.approvalTemplateList.length; i++) {
                            //     let templateInfo = this.approvalTemplateList[i];
                            //     if (templateInfo.dataOperate.forms && templateInfo.dataOperate.forms.length == 1 && templateInfo.dataOperate.forms[0].formId === this.approvalForm.formId) {
                            //         this.templateInfo = this.approvalTemplateList[i];
                            //         hasTemplateCnt = hasTemplateCnt + 1;
                            //     }
                            // }
                        }
                    }
                    // console.log(hasTemplateCnt);
                    if (hasTemplateCnt > 1) {
                        this.$message.error('含多条包含该任务表单的审批模板,请从审批流列表发起!');
                    } else if (hasTemplateCnt === 0) {
                        this.$message.error('没有配置只包含该任务表单的审批模板,请从审批流列表发起或联系管理员处理!');
                    } else if (hasTemplateCnt === 1) {
                        if (similarityBo.warnFlag) {
                            this.$confirm('与系统中已有的数据相似度达【' + similarityBo.similarity + '%】,是否继续发起审批流？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(async (ret) => {
                                // let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                                // let currentUserInfo = JSON.parse(currentUserStr);
                                this.approvalTitle = '发起【' + this.templateInfo.templateName + '】审批申请';
                                this.templateInfo.remarks = '';
                                this.templateInfo.selectedUser = {};
                                if (!isEmpty(this.templateInfo.selectedUserIds)) {
                                    if (this.templateInfo.clearApprovalUsers) {
                                        this.templateInfo.selectedUser.selectedUserIds = '';
                                        this.templateInfo.selectedUser.selectedUserNames = '';
                                        this.templateInfo.selectedUserIds = '';
                                        this.templateInfo.selectedUserNames = '';
                                    } else {
                                        this.templateInfo.selectedUser.selectedUserIds = this.templateInfo.selectedUserIds;
                                        this.templateInfo.selectedUser.selectedUserNames = this.templateInfo.selectedUserNames;
                                    }
                                } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                                    this.templateInfo.selectedUser.selectedUserIds = '';
                                    this.templateInfo.selectedUser.selectedUserNames = '';
                                }
                                this.setTaskParam();
    
                                this.approvalInstanceId = this.generateUUID();
                                setTimeout(() => { // 默认回显值
                                    this.$refs.approvalPop._initPage();
                                }, 0);
    
                                // 关联子表数据带给审批流
                                // console.log(this.approvalForm);
                                let mainModelInfo = {instanceId: this.approvalForm.values.id, relateModelList: this.relateModelList, formId: this.forms[0].id, modelId: this.forms[0].modelId, tempFormData: this.tempFormData};
                                this.templateInfo.mainModelInfo = mainModelInfo;
                                // console.log(mainModelInfo);
                                this.isShowApprovalPop = true;
                            }).catch(() => {
                                return false;
                            });
                        } else {
                            // let currentUserStr = sessionStorage.getItem('currentUserInfo');
                            // let currentUserInfo = JSON.parse(currentUserStr);
                            this.approvalTitle = '发起【' + this.templateInfo.templateName + '】审批申请';
                            this.templateInfo.remarks = '';
                            this.templateInfo.selectedUser = {};
                            if (!isEmpty(this.templateInfo.selectedUserIds)) {
                                if (this.templateInfo.clearApprovalUsers) {
                                    this.templateInfo.selectedUser.selectedUserIds = '';
                                    this.templateInfo.selectedUser.selectedUserNames = '';
                                    this.templateInfo.selectedUserIds = '';
                                    this.templateInfo.selectedUserNames = '';
                                } else {
                                    this.templateInfo.selectedUser.selectedUserIds = this.templateInfo.selectedUserIds;
                                    this.templateInfo.selectedUser.selectedUserNames = this.templateInfo.selectedUserNames;
                                }
                            } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                                this.templateInfo.selectedUser.selectedUserIds = '';
                                this.templateInfo.selectedUser.selectedUserNames = '';
                            }
                            this.setTaskParam();
    
                            this.approvalInstanceId = this.generateUUID();
                            setTimeout(() => { // 默认回显值
                                this.$refs.approvalPop._initPage();
                            }, 0);
    
                            // 关联子表数据带给审批流
                            // console.log(this.approvalForm);
                            let mainModelInfo = {instanceId: this.approvalForm.values.id, relateModelList: this.relateModelList, formId: this.forms[0].id, modelId: this.forms[0].modelId, tempFormData: this.tempFormData};
                            this.templateInfo.mainModelInfo = mainModelInfo;
                            // console.log(mainModelInfo);
                            this.isShowApprovalPop = true;
                        }
                    }
                }
            },
            async handleApply () {
                setTimeout(() => { // 默认回显值
                    let isToApproval = this.$refs.approvalPop.isToApproval();
                    if (!isToApproval) {
                        return;
                    }
                    this.hasApplyUser = this.$refs.approvalPop.hasApplyUser();
                    if (this.hasApplyUser) {
                        this.$confirm(`审批人中含有申请人,您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                this.tabName = 'sixth';
                                this.isShowMyApproval = true;
                                setTimeout(() => {
                                    this.$refs.myApproval.handleRefrenshApprovalList();
                                }, 0);
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {
                        });
                    } else {
                        // opType 操作模式：1 保存草稿 2发起审批
                        this.$confirm(`您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                this.tabName = 'sixth';
                                this.isShowMyApproval = true;
                                setTimeout(() => {
                                    this.$refs.myApproval.handleRefrenshApprovalList();
                                }, 0);
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {});
                    }
                }, 100);
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            async previewFile (file) {
                let previewUrl = await getPreviewFileUrl(file);
                if (previewUrl) {
                    this.previewUrl = previewUrl;
                    // this.isShowPreview = true;
                    // this.tabName = 'fifth';
                    let tempwindow = window.open();
                    tempwindow.location = previewUrl;
                }
            },
            chooseUser() {
                this.loadTimerUser = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectTrigger (selected) {
                this.assigneeUser = selected.selectedUserIds;
            },
            handleTransferAssignee () {
                this.isShowTransferAssigneeDialog = true;
                this.assigneeUser = '';
                let selectedUser = {};
                selectedUser.trueName = '';
                selectedUser.userId = '';
            },
            transferTask () {
                let param = {
                    taskId: this.taskInfo.id,
                    userId: this.assigneeUser,
                    processInstanceId: this.taskInfo.processInstanceId,
                    taskName: this.taskInfo.name
                };
                this.$emit('transferTask', param);
                this.isShowTransferAssigneeDialog = false;
            },
            async handelShowDiagram () {
                await this.setProcessViewInfo();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.diagrams.setProcessState(false);
                    this.$refs.diagrams.resetDiagramUrl();
                }, 0);
            },
            async setProcessViewInfo () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.instances = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                let tasks = await getAllUserTask(this.instances.id, this.instances.processServiceId, null, this.instances.deploymentId);
                // console.log(tasks);
                this.taskList = tasks;
                let treeList = [];
                if (this.instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                loading.close();
            },
            handleFullScreenForApproval () {
                this.isFullScreenForApproval = true;
                this.isShowFullScreenForApproval = true;
            },
            hideFullScreenDialogForApproval () {
                this.isFullScreenForApproval = false;
                this.$refs.myApproval.handleRefrenshApprovalList();
            },
            handelShowForms () {
                this.processInfo.serviceName = this.taskInfo.processServiceName;
                this.processInfo.instanceName = this.taskInfo.processInstanceName;
                this.processInfo.processInstanceId = this.taskInfo.processInstanceId;
                this.processInfo.deploymentId = this.taskInfo.processDefinitionDeploymentId;
                this.loadTimer = new Date().getTime();
                this.isShowForms = true;
            },
            async handleFullScreen (instance, form) {
                this.formInfo.formObj = {};
                this.formInfo.formObj.instance = JSON.stringify(instance);
                this.formInfo.formObj.structure = [];
                this.formInfo.formObj.structure[0] = form;
                this.formInfo.modelName = form.modelName;
                this.formInfo.appName = form.appName;
                this.loadTimer = new Date().getTime();
                this.isShowModelDetail = true;
                this.setIsShowForm(false);
                setTimeout(() => {
                    this.$refs.modelDetailChild.loadFormData(this.formInfo, {isShowEdit: true}, {isCanEdit: true}, false);
                }, 0);
            },
            setIsShowForm (status) {
                this.isShowFormDetail = status;
            },
            async handleModelComplete (obj) {
                this.formData.forEach(form => {
                    if (form.formId === obj.forms[0].formId && obj.forms[0].values) {
                        form.values = obj.forms[0].values;
                    }
                });
                this.loadTimerList = new Date().getTime();
                if (obj.tempFormData) {
                    this.loadTimerRelate = new Date().getTime();
                    await this.getModelListByMainFormId();
                }
                this.isShowModelDetail = false;
                await this.handleTaskTemporarySave();
            },
            async linkToProcessDetail () {
                if (this.canViewProcessDetail) {
                    // console.log(this.isNewPage);
                    let mode = this.currentUserInfo.switchLayoutFlg === 2;
                    if (this.isNewPage || mode) {
                        this.instances = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                        // 流程实例ID，流程实例名称，流程实例状态
                        let processInstanceStr = {};
                        processInstanceStr.processInstanceId = this.instances.id;
                        processInstanceStr.processInstanceName = this.instances.name;
                        processInstanceStr.finish = this.instances.finish;
                        let processInstanceJson = JSON.stringify(processInstanceStr);
                        window.sessionStorage.setItem('navToProcessList', processInstanceJson);
                        if (this.isFromBusTab) { // 来源于新版的应用tab
                            this.$emit('navToBusiniessProcessTab');
                        } else {
                            // console.log(this.instances);
                            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                            let currentUserInfo = JSON.parse(currentUserStr);
                            if (this.instances.startedBy.id === currentUserInfo.userId) {
                                this.navMyProcessmyProcessStartedBy();
                            } else {
                                this.navMyProcessMyProcessParticipant();
                            }
                        }
                    } else {
                        window.sessionStorage.setItem('paramProcessInstanceId', this.taskInfo.processInstanceId);
                        this.navMyProcess();
                    }
                } else {
                    this.messageTip('您无流程权限，无法查看流程详情！', 'warning');
                }
            },
            // changeLeftList () {
            //     this.$emit('setShowleftList', this.isCollapse);
            // },
            changeLeftTree (isCollapse) {
                this.$emit('setShowleftList', isCollapse);
            },
            handelShowTaskInfo () {
                this.isShowTaskInfo = true;
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            async handleSaveSubProcess (row) { // 动态修改子流程
                if (this.taskInfo.subformSubprocessConfig.modelInstanceId) {
                    await this.editModuleData(this.taskInfo.subformSubprocessConfig.modelInstanceId);
                } else {
                    this.messageTip('找不到发起子流程配置对应的表单数据，请联系管理员处理', 'warning');
                }
            },
            async editModuleData (dataId) {
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.formInfoProcess = await getModelFormInstanceById(dataId);
                    if (this.formInfoProcess) {
                        this.formInfoProcess.modelName = this.formInfoProcess.modelName;
                        this.formInfoProcess.currentDataId = dataId;
                        this.formInfoProcess.formObj.canStartApproval = false;
                        this.activeProcess = true;
                        this.isShowFormProcess = false;
                        this.isProcessRead = false;
                        setTimeout(async () => { // 默认回显值
                            if (this.$refs.modelInstanceProcess) {
                                this.$refs.modelInstanceProcess.loadFormData(this.formInfoProcess, this.formBtnAuth, {id: dataId, isCanEdit: true}, false);
                            }
                        }, 0);
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            async handleModelCompleteProcess (model) {
                // console.log(model);
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await saveAppModelForm(model.modelId, model);
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
                this.isShowFormProcess = false;
                this.activeProcess = false;
                await this.refreshSubProcess();
            },
            setIsShowFormProcess (status) {
                this.isShowFormProcess = status;
            },
            hideEditDialog () {
                this.activeProcess = false;
                this.isShowFormProcess = false;
            },
            handleViewProcessTemplate (row) {
                this.viewParams.id = row.localProcessDefinitionId;
                this.viewParams.pModelId = '';
                this.viewParams.viewDiagram = true;
                this.isShowTemplateDiagram = true;
                setTimeout(() => {
                    this.$refs.detailView.setProcessState(this.viewParams);
                }, 0);
            },
            handleStartProcessInstance (row) {
                let process = {};
                process.id = row.subProcessDefinitionId;
                process.processServiceId = row.subProcessServiceId;
                process.deploymentId = row.subDeploymentId;
                process.parentProcessInstanceId = this.taskInfo.processInstanceId;
                process.parentProcessInstanceName = this.taskInfo.processInstanceName;
                this.loadTimerProcess = new Date().getTime();
                setTimeout(async () => { // 默认回显值
                    await this.$refs.processInstancePop.handleStartProcess(process);
                }, 0);

                this.isShowStartProcessDialog = true;
            },
            handleClosePop () {
                this.isShowStartProcessDialog = false;
            },
            async refreshSubProcess () {
                setTimeout(async () => { // 刷新流程列表
                    await this.$refs.myProcessListMode._initPage();

                    // 从任务里发起子流程，刷新父组件MyTaskListView的任务列表
                    this.$emit('refreshTaskDetail');
                }, 0);
                this.isShowStartProcessDialog = false;
            },
            async handelShowProcessRelate () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => {
                    this.$refs.processRelateTree._initPage();
                }, 0);
                this.isShowProcessRelate = true;
            },
            refreshTaskDetail (isApproval) {
                let param = {taskId: '', tabId: ''};
                param.taskId = this.taskInfo.id;
                param.tabId = 'first';
                if (isApproval) {
                    this.isApprovalRefresh = true;
                }
                if ((this.taskInfo.hasOwnProperty('formObj') && this.taskInfo.formObj.structure.length > 0) || this.btnConditions.length > 0 || this.isViewOperateOpinion) {
                    this.$emit('refreshTaskDetail', this.taskInfo.id);
                }
            },
            async handleShowProcessDetail () {
                this.isShowProcessDetail = false;
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.instancesInfo = await getProcessInstancesDetail(this.taskInfo.processInstanceId);
                loading.close();
                this.isShowProcessDetail = true;
            },
            loadLinkData (data, targetField) {
                for (let index = 0, len = this.forms.length; index < len; index++) {
                    if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                        for (var i = 0; i < this.forms[index].fieldsList.length; i++) {
                            let tempField = this.forms[index].fieldsList[i];
                            if (targetField.id === tempField.id) {
                                this.$refs['fieldItemChild' + i][0].initAddLinkData(data);
                            }
                        }
                    }
                }
            },
            cascadeControlViewField () { // 20230914 20230914 edit by hezhen 页面一开始初始化后级联处理关联数据带出的字段级联控制其显示字段的逻辑
                let cascedeStr = window.sessionStorage.getItem('fieldItemLinkInitCascedeStr');
                let cascedeArr = isEmpty(cascedeStr) ? null : JSON.parse(cascedeStr);
                if (!isEmpty(cascedeArr)) {
                    let cascadeFieldlMap = new Map();
                    window.sessionStorage.removeItem('fieldItemLinkInitCascedeStr');
                    for (var i = 0; i < cascedeArr.length; i++) {
                        let tempField = cascedeArr[i];
                        if (!cascadeFieldlMap.has(tempField.id)) {
                            cascadeFieldlMap.set(tempField.id, tempField);
                            this.cascadeViewField(tempField.id);
                        }
                    }
                }
            },
            async refreshViewField (relateModelMap) {
                // console.log(this.formData[0].values);
                // this.loadTimerField = new Date().getTime();
                this.cascadeControlViewField();
                if (relateModelMap && relateModelMap.size > 0) { // 级联显示子表单控制
                    this.relateModelMap = new Map();
                    this.relateModelMap = relateModelMap;
                    if (this.relateModelList) {
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let model = this.relateModelList[i];
                            if (relateModelMap.has(model.id)) {
                                model.hiddenElement = !relateModelMap.get(model.id);
                                if (relateModelMap.get(model.id)) {
                                    this.showRelateFormTab = true;
                                }
                            }
                        }
                        for (let i = 0; i < this.relateModelList.length; i++) {
                            let cur = this.relateModelList[i];
                            if (!cur.hiddenElement) {
                                this.relateFormTabName = cur.id;
                                await this.renderModelFormList(cur);
                                break;
                            }
                        }
                    }
                } else {
                    this.loadTimerField = new Date().getTime();
                }
            },
            handleStartProcessInstanceBatchAdd (row) {
                let process = {};
                process.id = row.subProcessDefinitionId;
                process.processServiceId = row.subProcessServiceId;
                process.deploymentId = row.subDeploymentId;
                process.parentProcessInstanceId = this.taskInfo.processInstanceId;
                process.parentProcessInstanceName = this.taskInfo.processInstanceName;
                this.loadTimerProcess = new Date().getTime();
                setTimeout(async () => { // 默认回显值
                    await this.$refs.processInstanceBatchAddPop._initPage_(process);
                }, 0);
                this.isShowStartProcessBatchAddDialog = true;
            },
            handleCloseBatchPop () {
                setTimeout(async () => { // 刷新流程列表
                    await this.$refs.myProcessListMode._initPage();
                    // 从任务里发起子流程，刷新父组件MyTaskListView的任务列表
                    this.$emit('refreshTaskDetail');
                }, 0);
                this.isShowStartProcessBatchAddDialog = false;
            },
            handleSelectFromHis (index, form) {
                this.formIndex = index;
                this.currentFormId = form.id;
                this.currentModelId = form.modelId;
                this.isShowDataCopyDialog = true;
            },
            reSetProcessFormData (data) { // 选择好复制的数据后，重置流程表单数据
                // console.log(this.formData[this.formIndex].attributes);
                // console.log(this.formData[this.formIndex].values);
                // console.log(data);
                // console.log(this.forms[this.formIndex].fieldsList);
                let selectValues = clone(data);
                let attributes = this.forms[this.formIndex].fieldsList;
                for (let i = 0; i < attributes.length; i++) { // 遍历
                    let item = attributes[i];
                    // console.log(item);
                    let prop = item.id;
                    let prop1 = prop + '-view';
                    let prop2 = prop + '-tree';
                    let prop3 = prop + '-user';
                    let prop4 = prop + '-sn';
                    if (item.type !== 'serialNumber' && item.type !== 'subform' && item.type !== 'link' && item.type !== 'file' && item.type !== 'process') {
                        if (!item.hasOwnProperty('isRead') || (item.hasOwnProperty('isRead') && !item.isRead)) { // 不含isRead属性或者isRead是false
                            if (item.type === 'user') {
                                this.formData[this.formIndex].values[prop] = '';
                                this.formData[this.formIndex].values[prop3] = '';
                            }
                            if (this.formData[this.formIndex].values.hasOwnProperty(prop) && selectValues.hasOwnProperty(prop)) {
                                this.formData[this.formIndex].values[prop] = selectValues[prop];
                            }
                            if (this.formData[this.formIndex].values.hasOwnProperty(prop1) && selectValues.hasOwnProperty(prop1)) {
                                this.formData[this.formIndex].values[prop1] = selectValues[prop1];
                            }
                            if (this.formData[this.formIndex].values.hasOwnProperty(prop2) && selectValues.hasOwnProperty(prop2)) {
                                this.formData[this.formIndex].values[prop2] = selectValues[prop2];
                            }
                            if (this.formData[this.formIndex].values.hasOwnProperty(prop3) && selectValues.hasOwnProperty(prop3)) {
                                this.formData[this.formIndex].values[prop3] = selectValues[prop3];
                            }
                            if (this.formData[this.formIndex].values.hasOwnProperty(prop4) && selectValues.hasOwnProperty(prop4)) {
                                this.formData[this.formIndex].values[prop4] = selectValues[prop4];
                            }
                        }
                    }
                }
                // console.log(this.formData[this.formIndex].values);
                this.refreshViewField();
                this.isShowDataCopyDialog = false;
            },
            handleCloneFromHis (index, form) {
                // if (this.taskInfo.formObj && this.taskInfo.formObj.instance.length > 1) {
                //     this.$message.error('被驳回的数据不支持再次引用，请联系管理员删除流程重新发起流程');
                // } else {
                this.formIndex = index;
                this.currentFormId = form.id;
                this.currentModelId = form.modelId;
                this.isShowDataCloneDialog = true;
                // }
            },
            cloneHisTaskFormData (data) { // 引用历史表单数据
                // 将formId、formDataId存入list，方便后续更新modelInstanceIds
                if (this.hisDataList && this.hisDataList.length > 0) {
                    let isHas = false;
                    for (let i = 0; i < this.hisDataList.length; i++) {
                        let item = this.hisDataList[i];
                        let formId = item.formId;
                        if (this.currentFormId === formId) {
                            isHas = true;
                            if (item.formDataId === data.sourceAppDataId) {
                                break;
                            } else {
                                item.formDataId = data.sourceAppDataId;
                            }
                        }
                    }
                    if (!isHas) {
                        let item = {
                            formId: this.currentFormId,
                            formDataId: data.sourceAppDataId
                        };
                        this.hisDataList.push(item);
                    }
                } else {
                    let item = {
                        formId: this.currentFormId,
                        formDataId: data.sourceAppDataId
                    };
                    this.hisDataList.push(item);
                }
                // console.log(this.hisDataList);
                let selectValues = clone(data);
                // 覆盖数据
                this.formData[this.formIndex].values = selectValues;
                this.refreshViewField();
                this.isShowDataCloneDialog = false;
            },
            getSubformName (formData, field) {
                if (Array.isArray(formData[field.id])) {
                    return field.name + '(' + formData[field.id].length + ')';
                } else {
                    return field.name + '(0)';
                }
            },
            isShowCascadeField (field, values) {
                return isFormFieldVisible(field, values);
            },
            isShowNormalField (field, index, formData) {
                if (!field || !formData || !formData.values || !isFormFieldVisible(field, formData.values)) {
                    return false;
                }
                let subFormViewMode = formData.values['subFormViewMode'];
                if (subFormViewMode !== 0 && (formData.ext1 === 1 || subFormViewMode === 1)) { // 子表单页签模式
                    if (field.type === 'subform') {
                        return false;
                    } else {
                        return true;
                    }
                } else if (formData.ext1 === 0 || !subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                    return true;
                }
            },
            async getModelListByMainFormId () {
                if (this.forms[0] && this.forms[0].id) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let modelList = await getModelListByMainFormId(this.forms[0].id);
                    this.relateModelList = modelList;
                    if (this.relateModelList && this.relateModelList.length > 0) {
                        // console.log(this.formInfo);
                        this.showRelateFormTab = true;
                        // 默认打开第一个关联表单数据
                        this.relateFormTabName = this.relateModelList[0].id;
                        this.renderModelFormList(this.relateModelList[0]);
                    } else {
                        this.showRelateFormTab = false;
                    }
                    loading.close();
                }
            },
            async renderModelFormList (model) {
                // 主表的formid
                model.mainFormId = this.forms[0].id;
                // 主表当前数据id
                model.mainFormDataId = null;
                this.formInfo = this.forms[0];
                this.formInfo.formId = model.mainFormId;
                // if (this.modelInstanceIds) {//此处可能是已经删除的数据id故直接用下面的后补ID可靠
                //     let instanceId = null;
                //     let jsonObj = JSON.parse(this.modelInstanceIds);
                //     for (var key in jsonObj) {
                //         if (this.forms[0] && this.forms[0].id === key) {
                //             instanceId = jsonObj[key];
                //         }
                //     }
                //     // console.log(instanceId);
                //     model.mainFormDataId = instanceId;
                // }
                if (!model.mainFormDataId) { // 后补mainFormDataId
                    for (let i = 0; i < this.formData.length; i++) {
                        let cur = this.formData[i];
                        if (cur.formId === model.mainFormId) {
                            model.mainFormDataId = cur.values.id;
                            break;
                        }
                    }
                }
                // 任务节点设置部门过滤子表单数据权限
                model.processInstanceIdAuth = this.taskInfo.processInstanceId;
                model.taskIdAuth = this.taskInfo.taskDefinitionKey;
                // this.loadTimerRelate = new Date().getTime();
                // console.log(model);
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs['relateModelList' + model.id] && this.$refs['relateModelList' + model.id][0]) {
                        this.$refs['relateModelList' + model.id][0].renderFormList(model);
                    }
                }, 1000);
            },
            async handleRelateFormTabClick (tab, event) {
                this.relateFormTabName = tab.name;
                for (var i = 0; i < this.relateModelList.length; i++) {
                    let model = this.relateModelList[i];
                    if (model.id === this.relateFormTabName) {
                        this.renderModelFormList(model);
                    }
                }
            },
            getTempFormData () {
                return isEmpty(this.tempFormData) ? null : this.tempFormData;
            },
            async asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, index) {
                if (selectTableColumns && Array.isArray(selectTableColumns)) {
                    let targetFormFieldlist = this.forms[index].fieldsList;
                    selectTableColumns.forEach(fieldObj => {
                        if (fieldObj.type === 'subform') {
                            // console.log(fieldObj);
                            // console.log(currentlinkFieldId);// 当前表单的关联字段id
                            targetFormFieldlist.forEach(element => {
                                // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                                if (element.options.dataSourceFieldId && element.options.dataSourceFieldId === currentlinkFieldId) {
                                    if (element.options.dataSourceSubFieldId) {
                                        if (element.options.dataSourceSubFieldId === fieldObj.id) {
                                            if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                                                for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                                    let tempField = this.forms[index].fieldsList[i];
                                                    if (element.id === tempField.id) {
                                                        this.$refs['fieldItemChild' + i][0].reSetSelectOptions(element, fieldObj, sourceData);
                                                    }
                                                }
                                            }
                                            // this.reSetSelectOptions(element, fieldObj, sourceData, index);
                                        }
                                    }
                                }
                            });
                        }
                    });
                    selectTableColumns.forEach(fieldObj => {
                        let sourceFieldLabel = fieldObj.label;
                        targetFormFieldlist.forEach(element => {
                            // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                            if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                                if (element.options.synLinkFormFieldId) {
                                    if (element.options.synLinkFormFieldId === fieldObj.id) {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                } else {
                                    if (sourceFieldLabel === element.name && element.type === 'text') {
                                        this.updSynLinkFieldData(element, fieldObj, sourceData, index);
                                    }
                                }
                            }
                        });
                    });
                }
                for (let i = 0; i < this.forms.length; i++) {
                    let form = this.forms[i];
                    let field = form.fieldsList.find(element => element.id === currentlinkFieldId);
                    if (field && field.options.ext2) {
                        let ext2 = field.options.ext2;
                        let ext2Obj = JSON.parse(ext2);
                        if (ext2Obj.automaticRecodeRefField) { // 配置了自动带出
                            let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                            let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                            for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                                let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                                let fieldObj = form.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                                if (fieldObj) {
                                    await this.getTableFirstRefData(fieldObj, form.fieldsList, index);
                                }
                            }
                        }
                    }
                }
            },
            async getTableFirstRefData (fieldObj, fieldsList, index) {
                let refTableData = [];
                let refTableColumn = [];
                this.searchParams.searchCondition = [];// 初始化搜索条件
                if (fieldObj.ext1 && this.searchParams.searchCondition.length === 0) { // 默认筛选值
                    let obj = JSON.parse(fieldObj.ext1);
                    this.defaultConditonsMap = new Map();
                    for (let key in obj) {
                        obj[key]['modelId'] = fieldObj.options.config.form.modelId;
                        this.searchParams.searchCondition.push(obj[key]);
                        this.defaultConditonsMap.set(obj[key].id, obj[key]);
                    }
                    this.searchCondition = this.searchParams.searchCondition;
                }
                // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await this.setDefaultConditionRef(fieldObj);
                for (let i = 0; i < this.searchParams.searchCondition.length; i++) {
                    let defaultCondition = this.searchParams.searchCondition[i];
                    if (defaultCondition.operateType === 7) { // 从表单字段值取值搜索
                        let searchvalue = this.formData[defaultCondition.valueFieldId];
                        let cur = fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                        let searchvalueView = '';
                        if (cur.type === 'category' || cur.type === 'select') {
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-view'];
                            let options = defaultCondition.options.config.options;
                            for (let i = 0; i < options.length; i++) {
                                let item = options[i];
                                if (item.title === searchvalueView) {
                                    searchvalue = item.value;
                                }
                            }
                        } else if (cur.type === 'department') {
                            searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                        } else if (cur.type === 'user') {
                            searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-user'];
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId];
                        } else if (cur.type === 'link') {
                            searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-link'];
                            searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-view'];
                        }
                        if (searchvalue) {
                            defaultCondition.conditionValue = searchvalue;
                            defaultCondition.conditionValueView = searchvalueView;
                            defaultCondition.operateType = 1;
                        }
                    }
                }
                // 处理关联字段值的搜索
                let formData = await getModelFormReportList({
                    currentPage: 1,
                    pageSize: 1,
                    modelId: fieldObj.options.config.form.modelId,
                    formId: fieldObj.options.config.form.formId,
                    isRelationSearch: true,
                    isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                    processInstanceId: this.processInstanceId,
                    searchCondition: this.searchParams.searchCondition
                });
                if (formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    refTableData = tableDatas;
                    loading.close();
                }
                if (formData.otherData) {
                    refTableColumn = formData.otherData.tableColumns;
                }
                //   this.loadTimer = new Date().getTime();
                if (fieldObj.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                    let cacheTableColumns = [];
                    for (let i = 0; i < refTableColumn.length; i++) {
                        let cur = refTableColumn[i];
                        if (fieldObj.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                            cacheTableColumns.push(cur);
                        }
                    }
                    refTableColumn = cacheTableColumns;
                }
                if (refTableData.length > 0) {
                    let param = {row: refTableData[0]};
                    this.handelSelectRefRow(param, fieldObj, refTableColumn, index);
                }
            },
            handelSelectRefRow (params, fieldObj, refTableColumn, index) { // TODO
                let selData = cloneDeep(params.row);
                let selectTableData = [selData];// 复制当前选中数据
                let linkData = this.setLinkTableData(refTableColumn, selectTableData[0]);
                let curFieldData = {
                    modelId: fieldObj.options.config.form.modelId,
                    tableColumns: refTableColumn,
                    tableData: [linkData]
                };
                this.formData[index].values[fieldObj.id] = curFieldData;
                this.formData[index].values[fieldObj.id + '-link'] = linkData.id;
                // this.formData[index].values[fieldObj.id + '-view'] = linkData[refTableColumn[1].id];
                this.formData[index].values[fieldObj.id + '-view'] = linkData[refTableColumn[0].id];
            },
            setLinkTableData (selectTableColumns, sourceFormObj) { // 增加关联字段显示字段的冗余字段数据
                let linkData = {};
                if (sourceFormObj) {
                    linkData['id'] = sourceFormObj.id;
                    if (selectTableColumns && selectTableColumns.length > 0) {
                        let selectcolumns = cloneDeep(selectTableColumns);
                        // console.log(selectcolumns);
                        selectcolumns.forEach(item => {
                            if (item.type === 'dictionary' || item.type === 'businessTree' || item.type === 'department') {
                                // -tree
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-tree'] = sourceFormObj[item.id + '-tree'];
                            } else if (item.type === 'user') {
                                // -user
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-user'] = sourceFormObj[item.id + '-user'];
                            } else if (item.type === 'category' || item.type === 'select' || item.type === 'file' || item.type === 'process' || item.type === 'address' || item.type === 'cascader' || item.type === 'role') {
                                // -view
                                linkData[item.id] = sourceFormObj[item.id];
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'calculation' || item.type === 'number' || item.type === 'text' || item.type === 'serialNumber' || item.type === 'date') {
                                linkData[item.id] = sourceFormObj[item.id];
                            } else if (item.type === 'link') {
                                linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                            } else if (item.type === 'subform') {
                                linkData[item.id] = sourceFormObj[item.id];
                            }
                        });
                    }
                }
                return linkData;
            },
            async setDefaultConditionRef (fieldObj) {
                if (fieldObj.options.ext3 && fieldObj.options.ext3 === '1' && !isEmpty(this.defaultConditonsMap)) { // 设置过滤条件为固定模式
                    if (this.searchParams.searchCondition && Array.isArray(this.searchParams.searchCondition)) {
                        let defaultConditons = [];
                        this.searchParams.searchCondition.forEach(conditiontObj => {
                            if (this.defaultConditonsMap.has(conditiontObj.id)) {
                                let defaultCondition = this.defaultConditonsMap.get(conditiontObj.id);
                                if (defaultCondition && defaultCondition.conditionValue) {
                                    defaultConditons.push(defaultCondition);
                                } else {
                                    defaultConditons.push(conditiontObj);
                                }
                            } else {
                                defaultConditons.push(conditiontObj);
                            }
                        });
                        if (!isEmpty(defaultConditons)) {
                            this.searchParams.searchCondition = defaultConditons;
                        }
                    }
                }
                if (fieldObj.options.ext2) {
                    let def = JSON.parse(fieldObj.options.ext2);
                    if (def.linkConfig) {
                        let linkConfig = JSON.parse(def.linkConfig);
                        if (linkConfig.linkConfigState) { // 需要过滤数据
                            this.searchParams.searchCondition = [];
                            let key = linkConfig.id + '-link';
                            let value = this.formData[0].values[key];
                            let curObj = JSON.parse(linkConfig.linkFieldObj);
                            curObj.conditionValue = value;
                            if (linkConfig.type !== 'link') {
                                curObj.operateType = 2;
                            } else {
                                curObj.operateType = 7;
                            }
                            curObj.valueFieldId = linkConfig.id;
                            this.searchParams.searchCondition.push(curObj);
                        }
                    }
                }
                await this.setLinkLimitDataRef(fieldObj);
            },
            async setLinkLimitDataRef (fieldObj) {
                if (fieldObj.options.ext2) { // 子表单的值进行约束，例如只能查看自己作为项目成员参与的项目列表
                    let json = JSON.parse(fieldObj.options.ext2);
                    if (json.limitData === true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                        let relateFormId = fieldObj.options.config.form.formId; // 关联字段的关联表单id
                        let formData = await getFormConfig(relateFormId);
                        if (formData) {
                            let fieldsList = formData.fieldsList;
                            if (fieldsList && fieldsList.length > 0) {
                                let conditonsMap = new Map();
                                for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                                    let limitField = json.limitFieldDataArray[i];
                                    if (limitField.subFormFieldId) {
                                        let linkPropFieldId = limitField.linkPropFieldId;// 子表单字段
                                        let subFormFieldId = limitField.subFormFieldId;
                                        conditonsMap.set(linkPropFieldId, linkPropFieldId + ',' + subFormFieldId);
                                    }
                                }
                                for (let k = 0; k < fieldsList.length; k++) {
                                    let curfield = fieldsList[k];
                                    if (curfield.type === 'subform' && conditonsMap.has(curfield.id)) {
                                        let targetStr = conditonsMap.get(curfield.id);
                                        curfield.filterMainFieldId = targetStr.split(',')[0];
                                        curfield.filterSubField = targetStr.split(',')[1];
                                        this.searchParams.searchCondition.push(curfield);
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // 修改配置了关联映射的字段值
            updSynLinkFieldData (element, fieldObj, sourceData, index) {
                // console.log(sourceData);
                // console.log(element);
                let type = fieldObj.type;
                let sourceValueKey = ''; // 对应userId等唯一性值
                let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
                let can = false; // 是否支持级联显示
                let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
                if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                    // -tree
                    can = true;
                    sourceDepartmentValueKey = sourceData[fieldObj.id];
                    sourceValue = sourceData[fieldObj.id + '-tree'];
                } else if (type === 'user') {
                    // -user
                    can = true;
                    sourceValueKey = sourceData[fieldObj.id];
                    sourceValue = sourceData[fieldObj.id + '-user'];
                } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                    // -view
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                    if (element.options && element.options.synLinkFormField && (element.options.synLinkFormField.type && element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi')) {
                        let cacheValue = sourceData[fieldObj.id];
                        let cacheValueArray = [];
                        for (let i = 0; i < fieldObj.otherSetting.colorOne.length; i++) {
                            let cur = fieldObj.otherSetting.colorOne[i];
                            if (cacheValue.indexOf(cur.value) !== -1) {
                                cacheValueArray.push(cur.title);
                            }
                        }
                        sourceValue = cacheValueArray.join(',');
                    }
                } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                } else if (type === 'link') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id + '-view'];
                } else if (type === 'subform') {
                    can = true;
                    sourceValue = sourceData[fieldObj.id];
                }
                if (can) {
                    if (element.type === 'text') {
                        this.formData[index].values[element.id] = sourceValue;
                        this.formData[index].values[element.id + '-view'] = '';
                    } else if (element.type === 'number' || element.type === 'calculation') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[index].values[element.id] = sourceValue;
                            this.formData[index].values[element.id + '-view'] = '';
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'user') {
                        // console.log(element);
                        // fieldId-user: trueName ，fieldId: userId
                        // console.log(sourceValue);
                        // console.log(sourceValueKey);
                        if (!isEmpty(sourceValue)) {
                            this.formData[index].values[element.id] = sourceValueKey;
                            this.formData[index].values[element.id + '-user'] = sourceValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-user'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'department') {
                        if (!isEmpty(sourceValue)) {
                            this.formData[0].values[element.id] = sourceDepartmentValueKey;
                            this.formData[0].values[element.id + '-tree'] = sourceValue;
                        } else {
                            this.formData[0].values[element.id] = '';
                            this.formData[0].values[element.id + '-tree'] = '';
                        }
                        this.refreshViewField();
                    } else if (element.type === 'select') {
                        // console.log(element);
                        if (!isEmpty(sourceValue)) {
                            // 下拉选项值
                            let targetFieldValue = {};
                            if (element.options) {
                                let targetFieldOptions = element.options.config.options;
                                for (let i = 0; i < targetFieldOptions.length; i++) {
                                    let optionItem = targetFieldOptions[i];
                                    if (optionItem.title === sourceValue) {
                                        targetFieldValue = optionItem;
                                        break;
                                    }
                                }
                            }
                            if (targetFieldValue) {
                                this.formData[index].values[element.id] = targetFieldValue.value;
                                this.formData[index].values[element.id + '-view'] = targetFieldValue.title;
                            }
                            /** *********  start      add by hezhen 20230711 增加选择关联数据后级联带出下拉或选项字段时，对应下拉和选项字段还存在级联显示字段设置的情况   *******************/
                            this.cascadeViewField(element.id);
                            /** *********   end        add by hezhen 20230711 增加选择关联数据后级联带出下拉或选项字段时，对应下拉和选项字段还存在级联显示字段设置的情况  *******************/
                        } else {
                            this.formData[index].values[element.id] = '';
                            this.formData[index].values[element.id + '-view'] = '';
                        }
                    } else if (element.type === 'subform') {
                        let sourceSubColumns = fieldObj.subColumns;
                        if (isEmpty(sourceSubColumns) && fieldObj.options) { // 智能关联，需要这样取值
                            sourceSubColumns = fieldObj.options.fieldList;
                            for (let k = 0; k < sourceSubColumns.length; k++) {
                                sourceSubColumns[k].label = sourceSubColumns[k].name;
                            }
                        }
                        let taragetSubColumns = element.options.fieldList;
                        let newValue = [];
                        if (!isEmpty(sourceValue)) {
                            for (let i = 0; i < sourceValue.length; i++) {
                                let sourceItemValue = sourceValue[i];
                                let targetItemValue = {};
                                // console.log(sourceItemValue);
                                for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                    let targetColumn = taragetSubColumns[j];
                                    for (let k = 0; k < sourceSubColumns.length; k++) {
                                        let sourceColumn = sourceSubColumns[k];
                                        if (targetColumn.label === sourceColumn.label) {
                                            if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                                // -tree
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                            } else if (sourceColumn.type === 'user') {
                                                // -user
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                            } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                                // -view
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                            } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                                targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (!isEmpty(targetItemValue)) {
                                    newValue.push(targetItemValue);
                                }
                            }
                            // console.log(newValue);
                            this.formData[index].values[element.id] = newValue;
                        } else {
                            this.formData[index].values[element.id] = '';
                        }
                        if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                            for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                let tempField = this.forms[index].fieldsList[i];
                                if (element.id === tempField.id) {
                                    setTimeout(() => {
                                        // 调用子组件的方法
                                        if (this.$refs['fieldItemChild' + i]) {
                                            this.$refs['fieldItemChild' + i][0].refreshFieldItemValue(this.formData[index].values[element.id]);
                                        }
                                    }, 10);
                                }
                            }
                        }
                    }
                }
            },
            // reSetSelectOptions (element, fieldObj, sourceData, index) {
            //     let type = fieldObj.type;
            //     let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
            //     if (type === 'subform') {
            //         sourceValue = sourceData[fieldObj.id];
            //         if (element.type === 'select') {
            //             let sourceSubColumns = fieldObj.subColumns;
            //             if (isEmpty(sourceSubColumns)) { // 智能关联，需要这样取值
            //                 sourceSubColumns = fieldObj.options.fieldList;
            //                 for (let k = 0; k < sourceSubColumns.length; k++) {
            //                     sourceSubColumns[k].label = sourceSubColumns[k].name;
            //                 }
            //             }
            //             let newOptions = [];
            //             // console.log(sourceSubColumns);
            //             // console.log(taragetSubColumns);
            //             // console.log(element);
            //             // console.log(sourceValue);
            //             if (!isEmpty(sourceValue)) {
            //                 for (let i = 0; i < sourceValue.length; i++) {
            //                     let sourceItemValue = sourceValue[i];
            //                     let targetItemValue = {
            //                         id: '',
            //                         title: '',
            //                         value: '',
            //                         def: false,
            //                         optionConfigId: element.options.config.id,
            //                         formId: element.formId
            //                     };
            //                     // console.log(sourceItemValue);
            //                     for (let k = 0; k < sourceSubColumns.length; k++) {
            //                         let sourceColumn = sourceSubColumns[k];
            //                         if (element.name === sourceColumn.label) {
            //                             if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
            //                                 // -tree
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-tree'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-tree'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-tree'];
            //                             } else if (sourceColumn.type === 'user') {
            //                                 // -user
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-user'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-user'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-user'];
            //                             } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
            //                                 // -view
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id + '-view'];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id + '-view'];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id + '-view'];
            //                             } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
            //                                 targetItemValue.title = sourceItemValue[sourceColumn.id];
            //                                 targetItemValue.label = sourceItemValue[sourceColumn.id];
            //                                 targetItemValue.value = sourceItemValue[sourceColumn.id];
            //                             }
            //                             break;
            //                         }
            //                     }
            //                     if (!isEmpty(targetItemValue)) {
            //                         newOptions.push(targetItemValue);
            //                     }
            //                 }
            //             }
            //             // console.log(newOptions);
            //             // 重置选项list
            //             // let formInfo = this.formInfo.formObj.structure[0];
            //             // if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
            //             //     for (var i = 0; i < formInfo.fieldsList.length; i++) {
            //             //         let tempField = formInfo.fieldsList[i];
            //             //         if (element.id === tempField.id) {
            //             //             this.$refs['fieldItemChild' + i][0].resetSelectFieldOptions(newOptions);
            //             //         }
            //             //     }
            //             // }
            //             if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
            //                 for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
            //                     let tempField = this.forms[index].fieldsList[i];
            //                     if (element.id === tempField.id) {
            //                         this.$refs['fieldItemChild' + i][0].resetSelectFieldOptions(newOptions);
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // },
            cascadeViewField (id) {
            /** *********  start      add by hezhen 20230711 增加选择关联数据后级联带出下拉或选项字段时，对应下拉和选项字段还存在级联显示字段设置的情况   *******************/
                let formInfo = this.taskInfo.formObj.structure[0];
                if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                    this.loadTimerField = new Date().getTime();
                    for (var i = 0; i < formInfo.fieldsList.length; i++) {
                        let tempField = formInfo.fieldsList[i];
                        let tempRefName = 'fieldItemChild' + i;
                        if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                            if (tempField.id === id) {
                                setTimeout(() => {
                                    // 设置下拉字段级联默认显示数据
                                    if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                        this.$refs[tempRefName][0].setCascadeData();
                                    }
                                }, 0);
                            }
                        }
                    }
                }
                /** *********   end        add by hezhen 20230711 增加选择关联数据后级联带出下拉或选项字段时，对应下拉和选项字段还存在级联显示字段设置的情况  *******************/
            },
            async exportReportList () {
                let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
                //     let modelId = this.taskInfo.reports[0].modelId;
                //     url = url.replace(':modelId', modelId).replace(':processInstanceId', this.taskInfo.processInstanceId).replace(':isApprovalForm', false).replace(':needSumData', false);
                this.exportLoading = true;
                await this.download(url);
                setTimeout(() => { // 导出按钮转圈圈关闭
                    this.exportLoading = false;
                }, 5000);
            // },
            // download (url) {
            //     var iframe = document.createElement('iframe');
            //     iframe.style.display = 'none';
            //     iframe.src = url;
            //     document.body.appendChild(iframe);
            },
            async download (url) {
                let param = {
                    modelId: this.taskInfo.reports[0].modelId,
                    formDataId: '', // 单条数据导出需要数据id
                    // reportExportprocessDataId: 'b8c0e7b4e20f44c09785d285a9f297ba',
                    isCurrentExport: 1
                };
                // TODO: 20210621这里需要根据配置的任务id来动态赋值，目前是写死了，后续做成可以配置的
                let pkMap = await getProcessInstanceTaskPkId({processInstanceId: this.taskInfo.processInstanceId, taskId: 'sid-8E064AFE-8A9F-4427-A117-BCB7DAF52A0B'});
                if (pkMap && pkMap.reportExportprocessDataId) {
                    param.reportExportprocessDataId = pkMap.reportExportprocessDataId;
                }
                param.page = JSON.stringify({currentPage: 1, pageSize: 10, totalPageNum: 1});
                let res = await getExcelDataExportId(param);
                if (res && res.data) {
                    url = `${API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID}`;
                    url = url.replace(':exportId', res.data);
                }
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            fieldIsRead (field) {
                if (field.formFieldAuth && field.formFieldAuth == '0') {
                    return true;
                } else {
                    return field.isRead;
                }
            },
            async handleApprovalDetail (index) {
                let approvalInstanceId = this.formData[index].approvalInstanceId;
                if (approvalInstanceId && this.formData[index].approvalStatusRecord) {
                    let loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    try {
                        this.approvalLoading = true;
                        this.approvalDetail = await getApprovalInstanceDetail(approvalInstanceId);
                    } catch (error) {
                        console.log(error);
                    } finally {
                        this.approvalLoading = false;
                        loading.close();
                    }
                }
            },
            activeClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-step';
                } else if (item.stepStatus === 2) {
                    return 'reject-step';
                } else if (item.stepStatus === 99) {
                    return 'now-step';
                } else {
                    return '';
                }
            },
            activeUserClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-user';
                } else if (item.stepStatus === 2) {
                    return 'reject-user';
                } else if (item.stepStatus === 99) {
                    return 'now-user';
                } else {
                    return '';
                }
            },
            asynFormUserFieldData (key, value, index) {
                if (this.formData[index] && this.formData[index].values) {
                    this.formData[index].values[key] = value;
                    this.loadTimerField = new Date().getTime();
                }
            },
            refTempFormData (obj) {
                this.renderCalculationField(obj);
            },
            async renderCalculationField (tempFormData) { // 主子表情况下，主表里有计算字段使用了子表的数据，还没提交后台时提前计算逻辑
                if (this.forms && this.forms.length > 0) {
                    let formInfo = this.forms[0];// 默认第一个
                    let isRefresh = false;
                    if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                        for (var i = 0; i < formInfo.fieldsList.length; i++) {
                            let tempField = formInfo.fieldsList[i];
                            if (tempField.type === 'calculation' && tempField.isView && tempField.ext2 !== '1') {
                                // console.log(tempField);
                                let param = {};
                                param.valuesNode = this.formData[0].values;
                                param.formulaExp = tempField.options.formulaExp;
                                param.tempFormData = tempFormData;
                                let res = await getCrossFieldData(param);
                                let finalVal = null;
                                if (res && res.finalVal) {
                                    finalVal = Number(res.finalVal);
                                    this.formData[0].values[tempField.id] = finalVal;
                                    isRefresh = true;
                                }
                            }
                        }
                        if (isRefresh) {
                            this.loadTimerField = new Date().getTime();
                        }
                    }
                }
            },
            dealFromLinkCache () { // 走中兴华咨报销分摊及请款分摊的流程模板时添加表单加载优化逻辑
                if (this.taskInfo.processServiceId === '6635353dcd16458caff1cded47e3bc29' || this.taskInfo.processServiceId === '94616d664c1547398916cd53abaa9c81') {
                    window.sessionStorage.setItem('isFormLinkLoadCacheMode', true);
                } else {
                    window.sessionStorage.removeItem('isFormLinkLoadCacheMode');
                }
            },
            isShowBsBtn (form) {
                if (this.userInfo.tenantId === '2a19bf2841304dd5b4ef566ed536ecf7' && form.id === '08cf7d614d294208bfc42049b4e396c5') {
                    return true;
                } else {
                    return false;
                }
            },
            sleep (ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            verifySpecialField (currentId) {
                this.$nextTick(() => {
                    let inputDomArr = document.getElementsByClassName('el-form-item is-error is-required');
                    for (let i = 0; i < inputDomArr.length; i++) {
                        let labelTemp = inputDomArr[i].getElementsByTagName('label');
                        if (labelTemp && labelTemp.length > 0) {
                            let id = labelTemp[0].getAttributeNode('for').value; // 取出第一个label参数for的值
                            if (id === currentId) {
                                inputDomArr[i].getElementsByClassName('el-form-item__content')[0].classList.add('requiredExtClass');
                                break;
                            }
                        }
                    }
                });
            },
            dealRequiredSpecialField (currentId) {
                this.verifySpecialField(currentId);
                this.$nextTick(() => {
                    let inputDomArr = document.getElementsByClassName('el-form-item is-success is-required');
                    for (let i = 0; i < inputDomArr.length; i++) {
                        let labelTemp = inputDomArr[i].getElementsByTagName('label');
                        if (labelTemp && labelTemp.length > 0) {
                            let id = labelTemp[0].getAttributeNode('for').value; // 取出第一个label参数for的值
                            if (id === currentId) {
                                inputDomArr[i].getElementsByClassName('el-form-item__content')[0].classList.remove('requiredExtClass');
                                break;
                            }
                        }
                    }
                });
            },
            dealSpecialField (fieldId) {
                this.$refs['customForm0'][0].validateField(fieldId);
                this.dealRequiredSpecialField(fieldId);
            },
            async jumpTask () { // TODO : 跳转指定节点功能，后续需要扩展
                let param = {processInstanceId: this.taskInfo.processInstanceId, targetTaskId: this.jumpTaskId};
                // let param = {processInstanceId: this.taskInfo.processInstanceId, targetTaskId: this.taskInfo.taskDefinitionKey};
                let res = jumpTaskProcessInstances(param);
                console.log(res);
                // this.$emit('transferTask', param);
            },
            async updAssignerUser() {
                let param = {processInstanceId: this.taskInfo.processInstanceId, taskId: this.updAssignerTaskId, newUserId: this.updAssignerUserId, role: 1};
                let res = involveUser(param);
                console.log(res);
            }
        }
    };
</script>

<style lang="less">
    .needWorkingPop{
        height: ~"calc(100% - 120px)";
        .el-drawer__header{
            margin-bottom: 24px;
        }
        .el-dialog__body,.el-drawer__body{
            height: ~"calc(100% - 120px)";
            .task-detail{
                width: 100%;
                height: 100%;
                overflow-y: auto;
                -webkit-box-flex: 1;
                flex: 1;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                flex-direction: column;
                .el-collapse-item__wrap {
                    padding: 0 20px;
                }

                .el-collapse {
                    width: 100%;
                    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
                    margin-bottom:2px
                    }
                }

                .taskInfo-btns {
                    position: absolute;
                    right: 20px;
                    top: 25px;
                }

                .task-desc {
                    position: relative;
                    .desc-content1 {
                        float:left;
                        width:25%;
                    }
                    .desc-content2 {
                        float:left;
                        width:15%;
                    }
                    .desc-content3 {
                        float:left;
                        width:30%;
                    }
                }
                .task-content {
                    height: ~"calc(100% - 120px)";
                    overflow: auto;
                    flex: 1;
                    display: flex;
                    flex-direction: row;
                    .el-tabs{
                        height: ~"calc(100% - 10px)";
                        width: 100%;
                        .el-tabs__content{
                            height: ~"calc(100% - 80px)";
                            overflow: auto;
                            .el-tab-pane{
                                height: ~"calc(100% - 10px)";
                                width: 100%;
                                .archive-my-process{
                                    width: 100%;
                                    .archiveFilesTabs{
                                         width: ~"calc(100% - 10px)";
                                        .process-design-tabs{
                                            width: ~"calc(100% - 10px)";
                                            .el-tabs__content{
                                                 width: 100%;
                                                .process-design-item{
                                                    width: ~"calc(100% - 20px)";
                                                    .process-design-item-content{
                                                        width: ~"calc(100% - 20px)";
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .content-taskForms{
                margin-top: 2px;
                // max-height: 480px;
                overflow-y: auto;
                .el-form-item__label{
                    color: #333;
                    font-weight: 700;
                }
                }
                .content-left {
                    // width: 90%;
                    margin: 0 5px;
                    overflow-y: auto;
                    width: 98%;
                    position: relative;
                }
                .content-right {
                    width: 36%;
                    overflow-y: auto;
                    .el-card__body{
                    padding:20px;
                    height:135px;
                    }
                }
                .comments {
                    width: 100%;
                    height: 350px;
                    overflow-y: auto;
                }
                .opinionClass:before {
                content: "*";
                color: #f56c6c;
                margin-right: 4px;
                }

            .my-task-list {
                    width: 100%;
                    height: ~"calc(100% - 10px)";
            }
            .taskdetail-top{
                position: relative;
                .taskInfo-btns{
                    position: absolute;
                    right: 20px;
                    top:25px;
                }
            }
            }
            .neewWorkingTask{
                // .task-detail{
                //     .task-content{
                //        .el-tabs{

                //        }
                //     }
                // }
                .el-tabs__content{
                    height: ~"calc(100% - 80px)";
                    overflow: auto;
                    .el-tab-pane{
                        height: ~"calc(100% - 10px)";
                    }
                }
                .task-content{
                    .el-tabs {
                        width: ~"calc(100% - 2px)";
                    }
                }
            }
        }
        .el-dialog__body{
            padding-bottom: 2px;
            padding-top: 2px;
            height: ~"calc(100% - 68px)";
        }
        .el-drawer__body{
            .taskInfo-btns{
                top:8px;
            }
            .drawerWorkTask{
            .task-content{
                .el-tabs{
                    height: ~"calc(100% - 10px)";
                    position: relative;
                    .el-tabs__content{
                        height: ~"calc(100% - 70px)";
                        // .my-task-list{
                        //     height: ~"calc(100% - 10px)";
                        //     .el-collapse-item{
                        //         height: 100%;
                        //         .el-collapse-item__wrap{
                        //             height: ~"calc(100% - 40px)";
                        //         }
                        //     }
                        // }
                    }
                }
            }
            }
        }
    }
    .wi-preview {
        height: 950px;
        display: flex;
        margin-top: -2%;
        .preview-page {
            flex: 1;
            width: 100%;
            // height: 900px;
        }
    }
    .el-collapse-title {
        // color: #409eff;
        color: #4ebe17;
        // font-size: 18px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > .el-button {
            margin-right: 10px;
        }
    }
    .popEditModelDetail{
        .el-dialog__body {
        padding: 5px 30px 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
        }
    }

    .processPopClass{
        .el-dialog__body {
            padding: 0px 0px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
        }
    }

    .success-step{
        .el-step__head{
            color: #67c23a;
            border-color: #67c23a;
            .is-success{
                color: #67c23a;
                border-color: #67c23a;
            }
        }
        .el-breadcrumb__inner{
                color: #c0c4cc;
                .is-success{
                    color: #67c23a;
                    border-color: #67c23a;
                }
        }
        .success-user .el-breadcrumb__inner{
            color: #67c23a;
        }
        .el-step__title{
            color: #67c23a;
        }
        .el-step__description{
            color: #303133;
        }
        .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #67c23a;
            color: #67c23a;
        }
    }
    .reject-step{
        .el-step__head{
            color: #f56c6c;
            border-color: #f56c6c;
        }
        .el-breadcrumb__inner{
                color: #c0c4cc;
        }
        .reject-user .el-breadcrumb__inner{
            color: #f56c6c;
        }
        .el-step__title{
            color: #f56c6c;
        }
        .el-step__description{
            color: #303133;
        }
    }
    .now-step{
        .el-step__head{
            color: #409eff;
            border-color: #409eff;
            .is-success{
                color: #409eff;
                border-color: #409eff;
            }
        }
        .el-breadcrumb__inner{
                color: #409eff;
                border-color: #409eff;
                .is-success{
                    color: #409eff;
                    border-color: #409eff;
                }
            }
        .el-step__title{
            color: #409eff;
            .is-process{
                font-weight: 700;
            }
        }
        .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #409eff;
            color: #409eff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyTask/TaskDetail.vue